<template>
<RF-Dialog
:cpntLargura='"800px"'
:cpntStatus="statusGeral"

:cpntAbaVet="abaVet"
:cpntAbaValue="abaVal"
:cpntAbaOnChange="demEdiProTabItemEditarOnChangeAba"

:cpntOnFecharDialog='demEdiProTabItemEditarFechar'>
  <template slot='titulo'>
    <svg class="fa fa-angle-double-right"></svg>
    Edição do Item <span v-html="cpntDados.nItem"></span>
    <br/>
    <span v-html="cpntDados.id_pro"></span> - <span v-html="cpntDados.id_pro_nome"></span>
  </template>

  <template slot='botoes'>
    <div class="dem-edi-pro-tab-item-botoes">
      <App-Button 
        :cpntIcone="'historico'"
        :cpntExplica="{ mensagem: 'Clique aqui para reinicializar os dados deste item.', posicaoMy: 'top right', posicaoAt: 'bottom left' }"
        @onClick="() => { demEdiProTabItemEditarSalvar(true) }"
      ></App-Button>

      <App-Button 
        :cpntIcone="'lupa'"
        :cpntExplica="{ mensagem: 'Clique aqui para buscar e atualizar os campos com a última atualização salva deste item.', posicaoMy: 'top right', posicaoAt: 'bottom left' }"
        @onClick="() => { demEdiProTabItemEditarBuscarProduto() }" 
      ></App-Button>
    </div>
  </template>

  <template slot='conteudo'>
    <div class="dem-edi-pro-tab-item-editar" :data-time="time" v-if="[ '', null, undefined ].indexOf(dados) === -1 && Object.keys(dados).length >= 1">
      <div v-show="abaVal === 'principal'">
        <div style="padding-top: 10px;">
          <div>
            <App-Autocompletar :data-time="time" class="dem-edi-pro-tab-item-editar--item"
              :cpntStatus='campos.item.status'
              :cpntId='campos.item.id'
              :cpntTabIndex='campos.item.tabIndex'
              :cpntNome='campos.item.nome'
              :cpntValue='campos.item.value'
              :cpntMensagem='campos.item.mensagem'
              :cpntMensagemTipo='campos.item.mensagemTipo'
              :cpntDisabled='cpntEditar === false || campos.item.disabled === true'
              :cpntMostrar='campos.item.mostrar'
              :cpntExplica='campos.item.explica'
              :cpntPlaceholder='campos.item.placeholder'
              :cpntValueRef='campos.item.valueRef'
              :cpntRouter='campos.item.router'
              :cpntMethod='campos.item.method'
              :cpntField='campos.item.field'
              :cpntFieldVirtual='campos.item.fieldVirtual'
              :cpntWhere='campos.item.where'
              :cpntAddButForm='campos.item.addButForm'
              :cpntKeyMostra='campos.item.keyMostra'
              :cpntTipoOrder='campos.item.tipoOrder'
              :cpntOrder='campos.item.order'
              :cpntOptions='campos.item.options'
              :cpntKeyValue='campos.item.keyValue'
              :cpntSearchMinimo='campos.item.searchMinimo'
              :cpntMask='campos.item.mask'
              :cpntNewOption='campos.item.newOption'

              :cpntOnChange='campos.item.onChange'
              :cpntOnBlur='campos.item.onBlur'
              :cpntOnRealizaBusca='campos.item.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.item.onKeyPressEnter'
              ref="item"
            ></App-Autocompletar>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--qtde"
              :cpntStatus='campos.qtde.status'
              :cpntId='campos.qtde.id'
              :cpntTabIndex='campos.qtde.tabIndex'
              :cpntNome='campos.qtde.nome'
              :cpntValue='campos.qtde.value'
              :cpntMensagem='campos.qtde.mensagem'
              :cpntMensagemTipo='campos.qtde.mensagemTipo'
              :cpntDisabled='cpntEditar === false || campos.qtde.disabled === true'
              :cpntMostrar='campos.qtde.mostrar'
              :cpntExplica='campos.qtde.explica'
              :cpntPlaceholder='campos.qtde.placeholder'
              :cpntValueRef='campos.qtde.valueRef'
              :cpntRouter='campos.qtde.router'
              :cpntField='campos.qtde.field'
              :cpntWhere='campos.qtde.where'
              :cpntAddButForm='campos.qtde.addButForm'
              :cpntKeyMostra='campos.qtde.keyMostra'
              :cpntTipoOrder='campos.qtde.tipoOrder'
              :cpntOrder='campos.qtde.order'
              :cpntOptions='campos.qtde.options'
              :cpntKeyValue='campos.qtde.keyValue'
              :cpntSearchMinimo='campos.qtde.searchMinimo'
              :cpntMask='campos.qtde.mask'

              :cpntOnChange='campos.qtde.onChange'
              :cpntOnBlur='campos.qtde.onBlur'
              :cpntOnRealizaBusca='campos.qtde.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.qtde.onKeyPressEnter'
              ref="qtde"
            ></App-Input>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--valor_uni"
              :cpntStatus='campos.valor_uni.status'
              :cpntId='campos.valor_uni.id'
              :cpntTabIndex='campos.valor_uni.tabIndex'
              :cpntNome='campos.valor_uni.nome'
              :cpntValue='campos.valor_uni.value'
              :cpntMensagem='campos.valor_uni.mensagem'
              :cpntMensagemTipo='campos.valor_uni.mensagemTipo'
              :cpntDisabled='cpntEditar === false || campos.valor_uni.disabled === true'
              :cpntMostrar='campos.valor_uni.mostrar'
              :cpntExplica='campos.valor_uni.explica'
              :cpntPlaceholder='campos.valor_uni.placeholder'
              :cpntValueRef='campos.valor_uni.valueRef'
              :cpntRouter='campos.valor_uni.router'
              :cpntField='campos.valor_uni.field'
              :cpntWhere='campos.valor_uni.where'
              :cpntAddButForm='campos.valor_uni.addButForm'
              :cpntKeyMostra='campos.valor_uni.keyMostra'
              :cpntTipoOrder='campos.valor_uni.tipoOrder'
              :cpntOrder='campos.valor_uni.order'
              :cpntOptions='campos.valor_uni.options'
              :cpntKeyValue='campos.valor_uni.keyValue'
              :cpntSearchMinimo='campos.valor_uni.searchMinimo'
              :cpntMask='campos.valor_uni.mask'

              :cpntOnChange='campos.valor_uni.onChange'
              :cpntOnBlur='campos.valor_uni.onBlur'
              :cpntOnRealizaBusca='campos.valor_uni.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.valor_uni.onKeyPressEnter'
              ref="valor_uni"
            ></App-Input>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--valor_tot"
              :cpntStatus='campos.valor_tot.status'
              :cpntId='campos.valor_tot.id'
              :cpntTabIndex='campos.valor_tot.tabIndex'
              :cpntNome='campos.valor_tot.nome'
              :cpntValue='campos.valor_tot.value'
              :cpntMensagem='campos.valor_tot.mensagem'
              :cpntMensagemTipo='campos.valor_tot.mensagemTipo'
              :cpntDisabled='cpntEditar === false || campos.valor_tot.disabled === true'
              :cpntMostrar='campos.valor_tot.mostrar'
              :cpntExplica='campos.valor_tot.explica'
              :cpntPlaceholder='campos.valor_tot.placeholder'
              :cpntValueRef='campos.valor_tot.valueRef'
              :cpntRouter='campos.valor_tot.router'
              :cpntField='campos.valor_tot.field'
              :cpntWhere='campos.valor_tot.where'
              :cpntAddButForm='campos.valor_tot.addButForm'
              :cpntKeyMostra='campos.valor_tot.keyMostra'
              :cpntTipoOrder='campos.valor_tot.tipoOrder'
              :cpntOrder='campos.valor_tot.order'
              :cpntOptions='campos.valor_tot.options'
              :cpntKeyValue='campos.valor_tot.keyValue'
              :cpntSearchMinimo='campos.valor_tot.searchMinimo'
              :cpntMask='campos.valor_tot.mask'

              :cpntOnChange='campos.valor_tot.onChange'
              :cpntOnBlur='campos.valor_tot.onBlur'
              :cpntOnRealizaBusca='campos.valor_tot.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.valor_tot.onKeyPressEnter'
              ref="valor_tot"
            ></App-Input>
          </div>

          <div v-if="[ 'NFCe', 'NFe' ].indexOf(cpntPDocTp) !== -1">
            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--valor_fre"
              :cpntStatus='campos.valor_fre.status'
              :cpntId='campos.valor_fre.id'
              :cpntTabIndex='campos.valor_fre.tabIndex'
              :cpntNome='campos.valor_fre.nome'
              :cpntValue='campos.valor_fre.value'
              :cpntMensagem='campos.valor_fre.mensagem'
              :cpntMensagemTipo='campos.valor_fre.mensagemTipo'
              :cpntDisabled='cpntEditar === false || campos.valor_fre.disabled === true'
              :cpntMostrar='campos.valor_fre.mostrar'
              :cpntExplica='campos.valor_fre.explica'
              :cpntPlaceholder='campos.valor_fre.placeholder'
              :cpntValueRef='campos.valor_fre.valueRef'
              :cpntRouter='campos.valor_fre.router'
              :cpntField='campos.valor_fre.field'
              :cpntWhere='campos.valor_fre.where'
              :cpntAddButForm='campos.valor_fre.addButForm'
              :cpntKeyMostra='campos.valor_fre.keyMostra'
              :cpntTipoOrder='campos.valor_fre.tipoOrder'
              :cpntOrder='campos.valor_fre.order'
              :cpntOptions='campos.valor_fre.options'
              :cpntKeyValue='campos.valor_fre.keyValue'
              :cpntSearchMinimo='campos.valor_fre.searchMinimo'
              :cpntMask='campos.valor_fre.mask'

              :cpntOnChange='campos.valor_fre.onChange'
              :cpntOnBlur='campos.valor_fre.onBlur'
              :cpntOnRealizaBusca='campos.valor_fre.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.valor_fre.onKeyPressEnter'
              ref="valor_fre"
            ></App-Input>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--valor_seg"
              :cpntStatus='campos.valor_seg.status'
              :cpntId='campos.valor_seg.id'
              :cpntTabIndex='campos.valor_seg.tabIndex'
              :cpntNome='campos.valor_seg.nome'
              :cpntValue='campos.valor_seg.value'
              :cpntMensagem='campos.valor_seg.mensagem'
              :cpntMensagemTipo='campos.valor_seg.mensagemTipo'
              :cpntDisabled='cpntEditar === false || campos.valor_seg.disabled === true'
              :cpntMostrar='campos.valor_seg.mostrar'
              :cpntExplica='campos.valor_seg.explica'
              :cpntPlaceholder='campos.valor_seg.placeholder'
              :cpntValueRef='campos.valor_seg.valueRef'
              :cpntRouter='campos.valor_seg.router'
              :cpntField='campos.valor_seg.field'
              :cpntWhere='campos.valor_seg.where'
              :cpntAddButForm='campos.valor_seg.addButForm'
              :cpntKeyMostra='campos.valor_seg.keyMostra'
              :cpntTipoOrder='campos.valor_seg.tipoOrder'
              :cpntOrder='campos.valor_seg.order'
              :cpntOptions='campos.valor_seg.options'
              :cpntKeyValue='campos.valor_seg.keyValue'
              :cpntSearchMinimo='campos.valor_seg.searchMinimo'
              :cpntMask='campos.valor_seg.mask'

              :cpntOnChange='campos.valor_seg.onChange'
              :cpntOnBlur='campos.valor_seg.onBlur'
              :cpntOnRealizaBusca='campos.valor_seg.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.valor_seg.onKeyPressEnter'
              ref="valor_seg"
            ></App-Input>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--valor_des"
              :cpntStatus='campos.valor_des.status'
              :cpntId='campos.valor_des.id'
              :cpntTabIndex='campos.valor_des.tabIndex'
              :cpntNome='campos.valor_des.nome'
              :cpntValue='campos.valor_des.value'
              :cpntMensagem='campos.valor_des.mensagem'
              :cpntMensagemTipo='campos.valor_des.mensagemTipo'
              :cpntDisabled='cpntEditar === false || campos.valor_des.disabled === true'
              :cpntMostrar='campos.valor_des.mostrar'
              :cpntExplica='campos.valor_des.explica'
              :cpntPlaceholder='campos.valor_des.placeholder'
              :cpntValueRef='campos.valor_des.valueRef'
              :cpntRouter='campos.valor_des.router'
              :cpntField='campos.valor_des.field'
              :cpntWhere='campos.valor_des.where'
              :cpntAddButForm='campos.valor_des.addButForm'
              :cpntKeyMostra='campos.valor_des.keyMostra'
              :cpntTipoOrder='campos.valor_des.tipoOrder'
              :cpntOrder='campos.valor_des.order'
              :cpntOptions='campos.valor_des.options'
              :cpntKeyValue='campos.valor_des.keyValue'
              :cpntSearchMinimo='campos.valor_des.searchMinimo'
              :cpntMask='campos.valor_des.mask'

              :cpntOnChange='campos.valor_des.onChange'
              :cpntOnBlur='campos.valor_des.onBlur'
              :cpntOnRealizaBusca='campos.valor_des.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.valor_des.onKeyPressEnter'
              ref="valor_des"
            ></App-Input>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--valor_oda"
              :cpntStatus='campos.valor_oda.status'
              :cpntId='campos.valor_oda.id'
              :cpntTabIndex='campos.valor_oda.tabIndex'
              :cpntNome='campos.valor_oda.nome'
              :cpntValue='campos.valor_oda.value'
              :cpntMensagem='campos.valor_oda.mensagem'
              :cpntMensagemTipo='campos.valor_oda.mensagemTipo'
              :cpntDisabled='cpntEditar === false || campos.valor_oda.disabled === true'
              :cpntMostrar='campos.valor_oda.mostrar'
              :cpntExplica='campos.valor_oda.explica'
              :cpntPlaceholder='campos.valor_oda.placeholder'
              :cpntValueRef='campos.valor_oda.valueRef'
              :cpntRouter='campos.valor_oda.router'
              :cpntField='campos.valor_oda.field'
              :cpntWhere='campos.valor_oda.where'
              :cpntAddButForm='campos.valor_oda.addButForm'
              :cpntKeyMostra='campos.valor_oda.keyMostra'
              :cpntTipoOrder='campos.valor_oda.tipoOrder'
              :cpntOrder='campos.valor_oda.order'
              :cpntOptions='campos.valor_oda.options'
              :cpntKeyValue='campos.valor_oda.keyValue'
              :cpntSearchMinimo='campos.valor_oda.searchMinimo'
              :cpntMask='campos.valor_oda.mask'

              :cpntOnChange='campos.valor_oda.onChange'
              :cpntOnBlur='campos.valor_oda.onBlur'
              :cpntOnRealizaBusca='campos.valor_oda.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.valor_oda.onKeyPressEnter'
              ref="valor_oda"
            ></App-Input>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--sub_total"
              :cpntStatus='campos.sub_total.status'
              :cpntId='campos.sub_total.id'
              :cpntTabIndex='campos.sub_total.tabIndex'
              :cpntNome='campos.sub_total.nome'
              :cpntValue='campos.sub_total.value'
              :cpntMensagem='campos.sub_total.mensagem'
              :cpntMensagemTipo='campos.sub_total.mensagemTipo'
              :cpntDisabled='cpntEditar === false || campos.sub_total.disabled === true'
              :cpntMostrar='campos.sub_total.mostrar'
              :cpntExplica='campos.sub_total.explica'
              :cpntPlaceholder='campos.sub_total.placeholder'
              :cpntValueRef='campos.sub_total.valueRef'
              :cpntRouter='campos.sub_total.router'
              :cpntField='campos.sub_total.field'
              :cpntWhere='campos.sub_total.where'
              :cpntAddButForm='campos.sub_total.addButForm'
              :cpntKeyMostra='campos.sub_total.keyMostra'
              :cpntTipoOrder='campos.sub_total.tipoOrder'
              :cpntOrder='campos.sub_total.order'
              :cpntOptions='campos.sub_total.options'
              :cpntKeyValue='campos.sub_total.keyValue'
              :cpntSearchMinimo='campos.sub_total.searchMinimo'
              :cpntMask='campos.sub_total.mask'

              :cpntOnChange='campos.sub_total.onChange'
              :cpntOnBlur='campos.sub_total.onBlur'
              :cpntOnRealizaBusca='campos.sub_total.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.sub_total.onKeyPressEnter'
              ref="sub_total"
            ></App-Input>
          </div>

          <div>
            <div :data-time="time" class="dem-edi-pro-tab-item-editar--cms_com_id" v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, null, null, null, null, false) === true">
              <div class="titulo">
                Vendedor
              </div>
              <div class="conteudo btn btn-default btn-sm app-cadastro-link" @click="demEdiProTabItemEditarVendedorOnClick(dados.id)">
                <template v-if="[ '', null, undefined ].indexOf(dados.cms_com_id) === -1">
                  <!-- SETA O NOME DO VENDEDOR -->
                  <span v-html="demEdiProTabItemEditarMontarNomeVendedor(dados)"></span>
                  
                  <!-- SETA A EXPLICAÇÃO DO VENDEDOR -->
                  <App-Explica :data-time='time' :key="'cms_con--' + dados.cms_com_id + '--cms_val--' + dados.cms_valor"
                    :cpntId='"dem-pro-tab-exp-vendedor--" + dados.id'
                    :cpntTitle='demEdiProTabItemEditarMontarExplicaVendedor(dados)'
                  ></App-Explica>
                </template>
                <template v-else>
                  ---
                </template>
              </div>
            </div>

            <App-Input :data-time="time" class="dem-edi-pro-tab-item-editar--xPed" v-if="[ 'NFCe', 'NFe' ].indexOf(cpntPDocTp) !== -1"
              :cpntStatus='campos.xPed.status'
              :cpntId='campos.xPed.id'
              :cpntTabIndex='campos.xPed.tabIndex'
              :cpntNome='campos.xPed.nome'
              :cpntValue='campos.xPed.value'
              :cpntMensagem='campos.xPed.mensagem'
              :cpntMensagemTipo='campos.xPed.mensagemTipo'
              :cpntDisabled='cpntEditar === false || campos.xPed.disabled === true'
              :cpntMostrar='campos.xPed.mostrar'
              :cpntExplica='campos.xPed.explica'
              :cpntPlaceholder='campos.xPed.placeholder'
              :cpntValueRef='campos.xPed.valueRef'
              :cpntRouter='campos.xPed.router'
              :cpntField='campos.xPed.field'
              :cpntWhere='campos.xPed.where'
              :cpntAddButForm='campos.xPed.addButForm'
              :cpntKeyMostra='campos.xPed.keyMostra'
              :cpntTipoOrder='campos.xPed.tipoOrder'
              :cpntOrder='campos.xPed.order'
              :cpntOptions='campos.xPed.options'
              :cpntKeyValue='campos.xPed.keyValue'
              :cpntSearchMinimo='campos.xPed.searchMinimo'
              :cpntMask='campos.xPed.mask'

              :cpntOnChange='campos.xPed.onChange'
              :cpntOnBlur='campos.xPed.onBlur'
              :cpntOnRealizaBusca='campos.xPed.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.xPed.onKeyPressEnter'
              ref="xPed"
            ></App-Input>

            <div :data-time="time" class="dem-edi-pro-tab-item-editar--id_pco_status" v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, [ 17 ], null, null, null, false) === true && this.$store.state.pcoAntigo === false">
              <div class="titulo">
                Lista de processo
              </div>
              <div class="conteudo" :class="dados.status_processo !== null ? 'btn btn-default btn-sm app-cadastro-link' : ''">
                <table v-if="dados.status_processo !== null" @click="() => { demEdiProTabItemEditarAbrirControleProcesso(dados) }">
                  <tr>
                    <td :style="'color: ' + dados.status_processo.cor_letra + '; background: ' + dados.status_processo.cor_fundo + ';'">
                      <span v-html="dados.status_processo.nome"></span>
                    </td>
                  </tr>
                </table>

                <!-- SETA O VALOR DA COLUNA -->
                <div v-else>---</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template v-if="[ '', null, undefined ].indexOf(abaVet.icms) === -1">
        <div v-show="abaVal === 'icms'">
          <div>
            <div style="padding-top: 15px; vertical-align: top;">
              <div class="dem-edi-pro-tab-item-editar--p_id_caso" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.id_caso) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time"
                  :cpntStatus='campos.p_id_caso.status'
                  :cpntId='campos.p_id_caso.id'
                  :cpntTabIndex='campos.p_id_caso.tabIndex'
                  :cpntNome='campos.p_id_caso.nome'
                  :cpntValue='campos.p_id_caso.value'
                  :cpntMensagem='campos.p_id_caso.mensagem'
                  :cpntMensagemTipo='campos.p_id_caso.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_id_caso.disabled === true'
                  :cpntMostrar='campos.p_id_caso.mostrar'
                  :cpntExplica='campos.p_id_caso.explica'
                  :cpntPlaceholder='campos.p_id_caso.placeholder'
                  :cpntValueRef='campos.p_id_caso.valueRef'
                  :cpntRouter='campos.p_id_caso.router'
                  :cpntField='campos.p_id_caso.field'
                  :cpntWhere='campos.p_id_caso.where'
                  :cpntAddButForm='campos.p_id_caso.addButForm'
                  :cpntKeyMostra='campos.p_id_caso.keyMostra'
                  :cpntTipoOrder='campos.p_id_caso.tipoOrder'
                  :cpntOrder='campos.p_id_caso.order'
                  :cpntOptions='campos.p_id_caso.options'
                  :cpntOptionInicialNome='campos.p_id_caso.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_id_caso.optionInicialValue'
                  :cpntKeyValue='campos.p_id_caso.keyValue'
                  :cpntSearchMinimo='campos.p_id_caso.searchMinimo'
                  :cpntMask='campos.p_id_caso.mask'

                  :cpntOnBuscarOptions='campos.p_id_caso.onBuscarOptions'
                  :cpntOnChange='campos.p_id_caso.onChange'
                  :cpntOnBlur='campos.p_id_caso.onBlur'
                  :cpntOnRealizaBusca='campos.p_id_caso.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_id_caso.onKeyPressEnter'
                  ref="p_id_caso"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_id_caso.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.id_caso }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_id_cfop" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.id_cfop) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time"
                  :cpntStatus='campos.p_id_cfop.status'
                  :cpntId='campos.p_id_cfop.id'
                  :cpntTabIndex='campos.p_id_cfop.tabIndex'
                  :cpntNome='campos.p_id_cfop.nome'
                  :cpntValue='campos.p_id_cfop.value'
                  :cpntMensagem='campos.p_id_cfop.mensagem'
                  :cpntMensagemTipo='campos.p_id_cfop.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_id_cfop.disabled === true'
                  :cpntMostrar='campos.p_id_cfop.mostrar'
                  :cpntExplica='campos.p_id_cfop.explica'
                  :cpntPlaceholder='campos.p_id_cfop.placeholder'
                  :cpntValueRef='campos.p_id_cfop.valueRef'
                  :cpntRouter='campos.p_id_cfop.router'
                  :cpntField='campos.p_id_cfop.field'
                  :cpntWhere='campos.p_id_cfop.where'
                  :cpntAddButForm='campos.p_id_cfop.addButForm'
                  :cpntKeyMostra='campos.p_id_cfop.keyMostra'
                  :cpntTipoOrder='campos.p_id_cfop.tipoOrder'
                  :cpntOrder='campos.p_id_cfop.order'
                  :cpntOptions='campos.p_id_cfop.options'
                  :cpntOptionInicialNome='campos.p_id_cfop.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_id_cfop.optionInicialValue'
                  :cpntKeyValue='campos.p_id_cfop.keyValue'
                  :cpntSearchMinimo='campos.p_id_cfop.searchMinimo'
                  :cpntMask='campos.p_id_cfop.mask'

                  :cpntOnBuscarOptions='campos.p_id_cfop.onBuscarOptions'
                  :cpntOnChange='campos.p_id_cfop.onChange'
                  :cpntOnBlur='campos.p_id_cfop.onBlur'
                  :cpntOnRealizaBusca='campos.p_id_cfop.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_id_cfop.onKeyPressEnter'
                  ref="p_id_cfop"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_id_cfop.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.id_cfop }"
                  ></App-Icone>
                </div>
              </div>
            </div>
          </div>
          
          <div class="titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            ICMS
          </div>
          <div class="quadrado">
            <div>
              <div class="dem-edi-pro-tab-item-editar--p_icms_origem" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.icms_orig) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time"
                  :cpntStatus='campos.p_icms_origem.status'
                  :cpntId='campos.p_icms_origem.id'
                  :cpntTabIndex='campos.p_icms_origem.tabIndex'
                  :cpntNome='campos.p_icms_origem.nome'
                  :cpntValue='campos.p_icms_origem.value'
                  :cpntMensagem='campos.p_icms_origem.mensagem'
                  :cpntMensagemTipo='campos.p_icms_origem.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_origem.disabled === true'
                  :cpntMostrar='campos.p_icms_origem.mostrar'
                  :cpntExplica='campos.p_icms_origem.explica'
                  :cpntPlaceholder='campos.p_icms_origem.placeholder'
                  :cpntValueRef='campos.p_icms_origem.valueRef'
                  :cpntRouter='campos.p_icms_origem.router'
                  :cpntField='campos.p_icms_origem.field'
                  :cpntWhere='campos.p_icms_origem.where'
                  :cpntAddButForm='campos.p_icms_origem.addButForm'
                  :cpntKeyMostra='campos.p_icms_origem.keyMostra'
                  :cpntTipoOrder='campos.p_icms_origem.tipoOrder'
                  :cpntOrder='campos.p_icms_origem.order'
                  :cpntOptions='campos.p_icms_origem.options'
                  :cpntOptionInicialNome='campos.p_icms_origem.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_origem.optionInicialValue'
                  :cpntKeyValue='campos.p_icms_origem.keyValue'
                  :cpntSearchMinimo='campos.p_icms_origem.searchMinimo'
                  :cpntMask='campos.p_icms_origem.mask'

                  :cpntOnBuscarOptions='campos.p_icms_origem.onBuscarOptions'
                  :cpntOnChange='campos.p_icms_origem.onChange'
                  :cpntOnBlur='campos.p_icms_origem.onBlur'
                  :cpntOnRealizaBusca='campos.p_icms_origem.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_icms_origem.onKeyPressEnter'
                  ref="p_icms_origem"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_icms_origem.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.icms_orig }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_icms_cst" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.icms_cst) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time"
                  :cpntStatus='campos.p_icms_cst.status'
                  :cpntId='campos.p_icms_cst.id'
                  :cpntTabIndex='campos.p_icms_cst.tabIndex'
                  :cpntNome='demEdiProTabItemEditarGerarNomeCstIcms'
                  :cpntValue='campos.p_icms_cst.value'
                  :cpntMensagem='campos.p_icms_cst.mensagem'
                  :cpntMensagemTipo='campos.p_icms_cst.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_cst.disabled === true'
                  :cpntMostrar='campos.p_icms_cst.mostrar'
                  :cpntExplica='campos.p_icms_cst.explica'
                  :cpntPlaceholder='campos.p_icms_cst.placeholder'
                  :cpntValueRef='campos.p_icms_cst.valueRef'
                  :cpntRouter='campos.p_icms_cst.router'
                  :cpntField='campos.p_icms_cst.field'
                  :cpntWhere='campos.p_icms_cst.where'
                  :cpntAddButForm='campos.p_icms_cst.addButForm'
                  :cpntKeyMostra='campos.p_icms_cst.keyMostra'
                  :cpntTipoOrder='campos.p_icms_cst.tipoOrder'
                  :cpntOrder='campos.p_icms_cst.order'
                  :cpntOptions='campos.p_icms_cst.options'
                  :cpntOptionInicialNome='campos.p_icms_cst.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_cst.optionInicialValue'
                  :cpntKeyValue='campos.p_icms_cst.keyValue'
                  :cpntSearchMinimo='campos.p_icms_cst.searchMinimo'
                  :cpntMask='campos.p_icms_cst.mask'

                  :cpntOnBuscarOptions='campos.p_icms_cst.onBuscarOptions'
                  :cpntOnChange='campos.p_icms_cst.onChange'
                  :cpntOnBlur='campos.p_icms_cst.onBlur'
                  :cpntOnRealizaBusca='campos.p_icms_cst.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_icms_cst.onKeyPressEnter'
                  ref="p_icms_cst"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_icms_cst.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.icms_cst }"
                  ></App-Icone>
                </div>
              </div>
            </div>

            <div style="padding-top: 25px">
              <div class="dem-edi-pro-tab-item-editar--p_icms_mod_bc" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.icms_mod_bc) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time"
                  :cpntStatus='campos.p_icms_mod_bc.status'
                  :cpntId='campos.p_icms_mod_bc.id'
                  :cpntTabIndex='campos.p_icms_mod_bc.tabIndex'
                  :cpntNome='campos.p_icms_mod_bc.nome'
                  :cpntValue='campos.p_icms_mod_bc.value'
                  :cpntMensagem='campos.p_icms_mod_bc.mensagem'
                  :cpntMensagemTipo='campos.p_icms_mod_bc.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_mod_bc.disabled === true'
                  :cpntMostrar='campos.p_icms_mod_bc.mostrar'
                  :cpntExplica='campos.p_icms_mod_bc.explica'
                  :cpntPlaceholder='campos.p_icms_mod_bc.placeholder'
                  :cpntValueRef='campos.p_icms_mod_bc.valueRef'
                  :cpntRouter='campos.p_icms_mod_bc.router'
                  :cpntField='campos.p_icms_mod_bc.field'
                  :cpntWhere='campos.p_icms_mod_bc.where'
                  :cpntAddButForm='campos.p_icms_mod_bc.addButForm'
                  :cpntKeyMostra='campos.p_icms_mod_bc.keyMostra'
                  :cpntTipoOrder='campos.p_icms_mod_bc.tipoOrder'
                  :cpntOrder='campos.p_icms_mod_bc.order'
                  :cpntOptions='campos.p_icms_mod_bc.options'
                  :cpntOptionInicialNome='campos.p_icms_mod_bc.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_mod_bc.optionInicialValue'
                  :cpntKeyValue='campos.p_icms_mod_bc.keyValue'
                  :cpntSearchMinimo='campos.p_icms_mod_bc.searchMinimo'
                  :cpntMask='campos.p_icms_mod_bc.mask'

                  :cpntOnBuscarOptions='campos.p_icms_mod_bc.onBuscarOptions'
                  :cpntOnChange='campos.p_icms_mod_bc.onChange'
                  :cpntOnBlur='campos.p_icms_mod_bc.onBlur'
                  :cpntOnRealizaBusca='campos.p_icms_mod_bc.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_icms_mod_bc.onKeyPressEnter'
                  ref="p_icms_mod_bc"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_icms_mod_bc.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.icms_mod_bc }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_icms_bc_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_icms_bc_v.status'
                  :cpntId='campos.p_icms_bc_v.id'
                  :cpntClassDivField='campos.p_icms_bc_v.classDivField'
                  :cpntNome='campos.p_icms_bc_v.nome'
                  :cpntValue='campos.p_icms_bc_v.value'
                  :cpntAutoComplete='campos.p_icms_bc_v.autocomplete'
                  :cpntMask='campos.p_icms_bc_v.mask'
                  :cpntOptionInicialNome='campos.p_icms_bc_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_bc_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_bc_v.disabled === true'
                  :cpntMostrar='campos.p_icms_bc_v.mostrar'
                  :cpntExplica='campos.p_icms_bc_v.explica'
                  :cpntAutoFocus='campos.p_icms_bc_v.autofocus'
                  :cpntMensagem='campos.p_icms_bc_v.mensagem'
                  :cpntMensagemTipo='campos.p_icms_bc_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_icms_bc_v.placeholder'
                  :cpntPosicionar='campos.p_icms_bc_v.posicionar'
                  :cpntOnChange='campos.p_icms_bc_v.onChange'
                  :cpntOnBlur='campos.p_icms_bc_v.onBlur'
                  ref='p_icms_bc_v'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_icms_a" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.icms_a) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_icms_a.status'
                  :cpntId='campos.p_icms_a.id'
                  :cpntClassDivField='campos.p_icms_a.classDivField'
                  :cpntNome='campos.p_icms_a.nome'
                  :cpntValue='campos.p_icms_a.value'
                  :cpntAutoComplete='campos.p_icms_a.autocomplete'
                  :cpntMask='campos.p_icms_a.mask'
                  :cpntOptionInicialNome='campos.p_icms_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_a.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_a.disabled === true'
                  :cpntMostrar='campos.p_icms_a.mostrar'
                  :cpntExplica='campos.p_icms_a.explica'
                  :cpntAutoFocus='campos.p_icms_a.autofocus'
                  :cpntMensagem='campos.p_icms_a.mensagem'
                  :cpntMensagemTipo='campos.p_icms_a.mensagemTipo'
                  :cpntPlaceholder='campos.p_icms_a.placeholder'
                  :cpntPosicionar='campos.p_icms_a.posicionar'
                  :cpntOnChange='campos.p_icms_a.onChange'
                  :cpntOnBlur='campos.p_icms_a.onBlur'
                  ref='p_icms_a'
                ></App-Input>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_icms_a.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.icms_a }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_icms_bc_p_r" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.icms_bc_p_r) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_icms_bc_p_r.status'
                  :cpntId='campos.p_icms_bc_p_r.id'
                  :cpntClassDivField='campos.p_icms_bc_p_r.classDivField'
                  :cpntNome='campos.p_icms_bc_p_r.nome'
                  :cpntValue='campos.p_icms_bc_p_r.value'
                  :cpntAutoComplete='campos.p_icms_bc_p_r.autocomplete'
                  :cpntMask='campos.p_icms_bc_p_r.mask'
                  :cpntOptionInicialNome='campos.p_icms_bc_p_r.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_bc_p_r.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_bc_p_r.disabled === true'
                  :cpntMostrar='campos.p_icms_bc_p_r.mostrar'
                  :cpntExplica='campos.p_icms_bc_p_r.explica'
                  :cpntAutoFocus='campos.p_icms_bc_p_r.autofocus'
                  :cpntMensagem='campos.p_icms_bc_p_r.mensagem'
                  :cpntMensagemTipo='campos.p_icms_bc_p_r.mensagemTipo'
                  :cpntPlaceholder='campos.p_icms_bc_p_r.placeholder'
                  :cpntPosicionar='campos.p_icms_bc_p_r.posicionar'
                  :cpntOnChange='campos.p_icms_bc_p_r.onChange'
                  :cpntOnBlur='campos.p_icms_bc_p_r.onBlur'
                  ref='p_icms_bc_p_r'
                ></App-Input>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_icms_bc_p_r.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.icms_bc_p_r }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_icms_bc_p_r_c" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.icms_bc_p_r_c) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time"
                  :cpntStatus='campos.p_icms_bc_p_r_c.status'
                  :cpntId='campos.p_icms_bc_p_r_c.id'
                  :cpntTabIndex='campos.p_icms_bc_p_r_c.tabIndex'
                  :cpntNome='campos.p_icms_bc_p_r_c.nome'
                  :cpntValue='campos.p_icms_bc_p_r_c.value'
                  :cpntMensagem='campos.p_icms_bc_p_r_c.mensagem'
                  :cpntMensagemTipo='campos.p_icms_bc_p_r_c.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_bc_p_r_c.disabled === true'
                  :cpntMostrar='campos.p_icms_bc_p_r_c.mostrar'
                  :cpntExplica='campos.p_icms_bc_p_r_c.explica'
                  :cpntPlaceholder='campos.p_icms_bc_p_r_c.placeholder'
                  :cpntValueRef='campos.p_icms_bc_p_r_c.valueRef'
                  :cpntRouter='campos.p_icms_bc_p_r_c.router'
                  :cpntField='campos.p_icms_bc_p_r_c.field'
                  :cpntWhere='campos.p_icms_bc_p_r_c.where'
                  :cpntAddButForm='campos.p_icms_bc_p_r_c.addButForm'
                  :cpntKeyMostra='campos.p_icms_bc_p_r_c.keyMostra'
                  :cpntTipoOrder='campos.p_icms_bc_p_r_c.tipoOrder'
                  :cpntOrder='campos.p_icms_bc_p_r_c.order'
                  :cpntOptions='campos.p_icms_bc_p_r_c.options'
                  :cpntOptionInicialNome='campos.p_icms_bc_p_r_c.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_bc_p_r_c.optionInicialValue'
                  :cpntKeyValue='campos.p_icms_bc_p_r_c.keyValue'
                  :cpntSearchMinimo='campos.p_icms_bc_p_r_c.searchMinimo'
                  :cpntMask='campos.p_icms_bc_p_r_c.mask'

                  :cpntOnBuscarOptions='campos.p_icms_bc_p_r_c.onBuscarOptions'
                  :cpntOnChange='campos.p_icms_bc_p_r_c.onChange'
                  :cpntOnBlur='campos.p_icms_bc_p_r_c.onBlur'
                  :cpntOnRealizaBusca='campos.p_icms_bc_p_r_c.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_icms_bc_p_r_c.onKeyPressEnter'
                  ref="p_icms_bc_p_r_c"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_icms_bc_p_r_c.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.icms_bc_p_r_c }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_icms_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_icms_v.status'
                  :cpntId='campos.p_icms_v.id'
                  :cpntClassDivField='campos.p_icms_v.classDivField'
                  :cpntNome='campos.p_icms_v.nome'
                  :cpntValue='campos.p_icms_v.value'
                  :cpntAutoComplete='campos.p_icms_v.autocomplete'
                  :cpntMask='campos.p_icms_v.mask'
                  :cpntOptionInicialNome='campos.p_icms_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_v.disabled === true'
                  :cpntMostrar='campos.p_icms_v.mostrar'
                  :cpntExplica='campos.p_icms_v.explica'
                  :cpntAutoFocus='campos.p_icms_v.autofocus'
                  :cpntMensagem='campos.p_icms_v.mensagem'
                  :cpntMensagemTipo='campos.p_icms_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_icms_v.placeholder'
                  :cpntPosicionar='campos.p_icms_v.posicionar'
                  :cpntOnChange='campos.p_icms_v.onChange'
                  :cpntOnBlur='campos.p_icms_v.onBlur'
                  ref='p_icms_v'
                ></App-Input>
              </div>
            </div>

            <div style="padding-top: 25px">
              <div class="dem-edi-pro-tab-item-editar--p_icms_st_bc_mod" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.icms_st_bc_mod) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time"
                  :cpntStatus='campos.p_icms_st_bc_mod.status'
                  :cpntId='campos.p_icms_st_bc_mod.id'
                  :cpntTabIndex='campos.p_icms_st_bc_mod.tabIndex'
                  :cpntNome='campos.p_icms_st_bc_mod.nome'
                  :cpntValue='campos.p_icms_st_bc_mod.value'
                  :cpntMensagem='campos.p_icms_st_bc_mod.mensagem'
                  :cpntMensagemTipo='campos.p_icms_st_bc_mod.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_st_bc_mod.disabled === true'
                  :cpntMostrar='campos.p_icms_st_bc_mod.mostrar'
                  :cpntExplica='campos.p_icms_st_bc_mod.explica'
                  :cpntPlaceholder='campos.p_icms_st_bc_mod.placeholder'
                  :cpntValueRef='campos.p_icms_st_bc_mod.valueRef'
                  :cpntRouter='campos.p_icms_st_bc_mod.router'
                  :cpntField='campos.p_icms_st_bc_mod.field'
                  :cpntWhere='campos.p_icms_st_bc_mod.where'
                  :cpntAddButForm='campos.p_icms_st_bc_mod.addButForm'
                  :cpntKeyMostra='campos.p_icms_st_bc_mod.keyMostra'
                  :cpntTipoOrder='campos.p_icms_st_bc_mod.tipoOrder'
                  :cpntOrder='campos.p_icms_st_bc_mod.order'
                  :cpntOptions='campos.p_icms_st_bc_mod.options'
                  :cpntOptionInicialNome='campos.p_icms_st_bc_mod.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_st_bc_mod.optionInicialValue'
                  :cpntKeyValue='campos.p_icms_st_bc_mod.keyValue'
                  :cpntSearchMinimo='campos.p_icms_st_bc_mod.searchMinimo'
                  :cpntMask='campos.p_icms_st_bc_mod.mask'

                  :cpntOnBuscarOptions='campos.p_icms_st_bc_mod.onBuscarOptions'
                  :cpntOnChange='campos.p_icms_st_bc_mod.onChange'
                  :cpntOnBlur='campos.p_icms_st_bc_mod.onBlur'
                  :cpntOnRealizaBusca='campos.p_icms_st_bc_mod.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_icms_st_bc_mod.onKeyPressEnter'
                  ref="p_icms_st_bc_mod"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_icms_st_bc_mod.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.icms_st_bc_mod }"
                  ></App-Icone>
                </div>
              </div>
              
              <div class="dem-edi-pro-tab-item-editar--p_icms_mva_p" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.icms_mva_p) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_icms_mva_p.status'
                  :cpntId='campos.p_icms_mva_p.id'
                  :cpntClassDivField='campos.p_icms_mva_p.classDivField'
                  :cpntNome='campos.p_icms_mva_p.nome'
                  :cpntValue='campos.p_icms_mva_p.value'
                  :cpntAutoComplete='campos.p_icms_mva_p.autocomplete'
                  :cpntMask='campos.p_icms_mva_p.mask'
                  :cpntOptionInicialNome='campos.p_icms_mva_p.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_mva_p.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_mva_p.disabled === true'
                  :cpntMostrar='campos.p_icms_mva_p.mostrar'
                  :cpntExplica='campos.p_icms_mva_p.explica'
                  :cpntAutoFocus='campos.p_icms_mva_p.autofocus'
                  :cpntMensagem='campos.p_icms_mva_p.mensagem'
                  :cpntMensagemTipo='campos.p_icms_mva_p.mensagemTipo'
                  :cpntPlaceholder='campos.p_icms_mva_p.placeholder'
                  :cpntPosicionar='campos.p_icms_mva_p.posicionar'
                  :cpntOnChange='campos.p_icms_mva_p.onChange'
                  :cpntOnBlur='campos.p_icms_mva_p.onBlur'
                  ref='p_icms_mva_p'
                ></App-Input>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_icms_mva_p.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.icms_mva_p }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_icms_st_bc_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_icms_st_bc_v.status'
                  :cpntId='campos.p_icms_st_bc_v.id'
                  :cpntClassDivField='campos.p_icms_st_bc_v.classDivField'
                  :cpntNome='campos.p_icms_st_bc_v.nome'
                  :cpntValue='campos.p_icms_st_bc_v.value'
                  :cpntAutoComplete='campos.p_icms_st_bc_v.autocomplete'
                  :cpntMask='campos.p_icms_st_bc_v.mask'
                  :cpntOptionInicialNome='campos.p_icms_st_bc_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_st_bc_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_st_bc_v.disabled === true'
                  :cpntMostrar='campos.p_icms_st_bc_v.mostrar'
                  :cpntExplica='campos.p_icms_st_bc_v.explica'
                  :cpntAutoFocus='campos.p_icms_st_bc_v.autofocus'
                  :cpntMensagem='campos.p_icms_st_bc_v.mensagem'
                  :cpntMensagemTipo='campos.p_icms_st_bc_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_icms_st_bc_v.placeholder'
                  :cpntPosicionar='campos.p_icms_st_bc_v.posicionar'
                  :cpntOnChange='campos.p_icms_st_bc_v.onChange'
                  :cpntOnBlur='campos.p_icms_st_bc_v.onBlur'
                  ref='p_icms_st_bc_v'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_icms_st_a" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.icms_st_a) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_icms_st_a.status'
                  :cpntId='campos.p_icms_st_a.id'
                  :cpntClassDivField='campos.p_icms_st_a.classDivField'
                  :cpntNome='campos.p_icms_st_a.nome'
                  :cpntValue='campos.p_icms_st_a.value'
                  :cpntAutoComplete='campos.p_icms_st_a.autocomplete'
                  :cpntMask='campos.p_icms_st_a.mask'
                  :cpntOptionInicialNome='campos.p_icms_st_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_st_a.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_st_a.disabled === true'
                  :cpntMostrar='campos.p_icms_st_a.mostrar'
                  :cpntExplica='campos.p_icms_st_a.explica'
                  :cpntAutoFocus='campos.p_icms_st_a.autofocus'
                  :cpntMensagem='campos.p_icms_st_a.mensagem'
                  :cpntMensagemTipo='campos.p_icms_st_a.mensagemTipo'
                  :cpntPlaceholder='campos.p_icms_st_a.placeholder'
                  :cpntPosicionar='campos.p_icms_st_a.posicionar'
                  :cpntOnChange='campos.p_icms_st_a.onChange'
                  :cpntOnBlur='campos.p_icms_st_a.onBlur'
                  ref='p_icms_st_a'
                ></App-Input>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_icms_st_a.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.icms_st_a }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_icms_bc_st_p_r" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.icms_bc_st_p_r) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_icms_bc_st_p_r.status'
                  :cpntId='campos.p_icms_bc_st_p_r.id'
                  :cpntClassDivField='campos.p_icms_bc_st_p_r.classDivField'
                  :cpntNome='campos.p_icms_bc_st_p_r.nome'
                  :cpntValue='campos.p_icms_bc_st_p_r.value'
                  :cpntAutoComplete='campos.p_icms_bc_st_p_r.autocomplete'
                  :cpntMask='campos.p_icms_bc_st_p_r.mask'
                  :cpntOptionInicialNome='campos.p_icms_bc_st_p_r.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_bc_st_p_r.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_bc_st_p_r.disabled === true'
                  :cpntMostrar='campos.p_icms_bc_st_p_r.mostrar'
                  :cpntExplica='campos.p_icms_bc_st_p_r.explica'
                  :cpntAutoFocus='campos.p_icms_bc_st_p_r.autofocus'
                  :cpntMensagem='campos.p_icms_bc_st_p_r.mensagem'
                  :cpntMensagemTipo='campos.p_icms_bc_st_p_r.mensagemTipo'
                  :cpntPlaceholder='campos.p_icms_bc_st_p_r.placeholder'
                  :cpntPosicionar='campos.p_icms_bc_st_p_r.posicionar'
                  :cpntOnChange='campos.p_icms_bc_st_p_r.onChange'
                  :cpntOnBlur='campos.p_icms_bc_st_p_r.onBlur'
                  ref='p_icms_bc_st_p_r'
                ></App-Input>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_icms_bc_st_p_r.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.icms_bc_st_p_r }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_icms_st_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_icms_st_v.status'
                  :cpntId='campos.p_icms_st_v.id'
                  :cpntClassDivField='campos.p_icms_st_v.classDivField'
                  :cpntNome='campos.p_icms_st_v.nome'
                  :cpntValue='campos.p_icms_st_v.value'
                  :cpntAutoComplete='campos.p_icms_st_v.autocomplete'
                  :cpntMask='campos.p_icms_st_v.mask'
                  :cpntOptionInicialNome='campos.p_icms_st_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_icms_st_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_icms_st_v.disabled === true'
                  :cpntMostrar='campos.p_icms_st_v.mostrar'
                  :cpntExplica='campos.p_icms_st_v.explica'
                  :cpntAutoFocus='campos.p_icms_st_v.autofocus'
                  :cpntMensagem='campos.p_icms_st_v.mensagem'
                  :cpntMensagemTipo='campos.p_icms_st_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_icms_st_v.placeholder'
                  :cpntPosicionar='campos.p_icms_st_v.posicionar'
                  :cpntOnChange='campos.p_icms_st_v.onChange'
                  :cpntOnBlur='campos.p_icms_st_v.onBlur'
                  ref='p_icms_st_v'
                ></App-Input>
              </div>
            </div>
          </div>
        </div>
        
        <div v-show="abaVal === 'pis'">
          <div class="titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            PIS
          </div>
          <div class="quadrado">
            <div>
              <div class="dem-edi-pro-tab-item-editar--p_pis_cst" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.pis_cst) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time" 
                  :cpntStatus='campos.p_pis_cst.status'
                  :cpntId='campos.p_pis_cst.id'
                  :cpntTabIndex='campos.p_pis_cst.tabIndex'
                  :cpntNome='campos.p_pis_cst.nome'
                  :cpntValue='campos.p_pis_cst.value'
                  :cpntMensagem='campos.p_pis_cst.mensagem'
                  :cpntMensagemTipo='campos.p_pis_cst.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_pis_cst.disabled === true'
                  :cpntMostrar='campos.p_pis_cst.mostrar'
                  :cpntExplica='campos.p_pis_cst.explica'
                  :cpntPlaceholder='campos.p_pis_cst.placeholder'
                  :cpntValueRef='campos.p_pis_cst.valueRef'
                  :cpntRouter='campos.p_pis_cst.router'
                  :cpntField='campos.p_pis_cst.field'
                  :cpntWhere='campos.p_pis_cst.where'
                  :cpntAddButForm='campos.p_pis_cst.addButForm'
                  :cpntKeyMostra='campos.p_pis_cst.keyMostra'
                  :cpntTipoOrder='campos.p_pis_cst.tipoOrder'
                  :cpntOrder='campos.p_pis_cst.order'
                  :cpntOptions='campos.p_pis_cst.options'
                  :cpntOptionInicialNome='campos.p_pis_cst.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_pis_cst.optionInicialValue'
                  :cpntKeyValue='campos.p_pis_cst.keyValue'
                  :cpntSearchMinimo='campos.p_pis_cst.searchMinimo'
                  :cpntMask='campos.p_pis_cst.mask'

                  :cpntOnBuscarOptions='campos.p_pis_cst.onBuscarOptions'
                  :cpntOnChange='campos.p_pis_cst.onChange'
                  :cpntOnBlur='campos.p_pis_cst.onBlur'
                  :cpntOnRealizaBusca='campos.p_pis_cst.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_pis_cst.onKeyPressEnter'
                  ref="p_pis_cst"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_pis_cst.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.pis_cst }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_pis_bc_v">
                <App-Input :data-time="time" 
                  :cpntStatus='campos.p_pis_bc_v.status'
                  :cpntId='campos.p_pis_bc_v.id'
                  :cpntClassDivField='campos.p_pis_bc_v.classDivField'
                  :cpntNome='campos.p_pis_bc_v.nome'
                  :cpntValue='campos.p_pis_bc_v.value'
                  :cpntAutoComplete='campos.p_pis_bc_v.autocomplete'
                  :cpntMask='campos.p_pis_bc_v.mask'
                  :cpntOptionInicialNome='campos.p_pis_bc_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_pis_bc_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_pis_bc_v.disabled === true'
                  :cpntMostrar='campos.p_pis_bc_v.mostrar'
                  :cpntExplica='campos.p_pis_bc_v.explica'
                  :cpntAutoFocus='campos.p_pis_bc_v.autofocus'
                  :cpntMensagem='campos.p_pis_bc_v.mensagem'
                  :cpntMensagemTipo='campos.p_pis_bc_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_pis_bc_v.placeholder'
                  :cpntPosicionar='campos.p_pis_bc_v.posicionar'
                  :cpntOnChange='campos.p_pis_bc_v.onChange'
                  :cpntOnBlur='campos.p_pis_bc_v.onBlur'
                  ref='p_pis_bc_v'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_pis_a" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.pis_a) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Input :data-time="time" 
                  :cpntStatus='campos.p_pis_a.status'
                  :cpntId='campos.p_pis_a.id'
                  :cpntClassDivField='campos.p_pis_a.classDivField'
                  :cpntNome='campos.p_pis_a.nome'
                  :cpntValue='campos.p_pis_a.value'
                  :cpntAutoComplete='campos.p_pis_a.autocomplete'
                  :cpntMask='campos.p_pis_a.mask'
                  :cpntOptionInicialNome='campos.p_pis_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_pis_a.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_pis_a.disabled === true'
                  :cpntMostrar='campos.p_pis_a.mostrar'
                  :cpntExplica='campos.p_pis_a.explica'
                  :cpntAutoFocus='campos.p_pis_a.autofocus'
                  :cpntMensagem='campos.p_pis_a.mensagem'
                  :cpntMensagemTipo='campos.p_pis_a.mensagemTipo'
                  :cpntPlaceholder='campos.p_pis_a.placeholder'
                  :cpntPosicionar='campos.p_pis_a.posicionar'
                  :cpntOnChange='campos.p_pis_a.onChange'
                  :cpntOnBlur='campos.p_pis_a.onBlur'
                  ref='p_pis_a'
                ></App-Input>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_pis_a.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.pis_a }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_pis_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_pis_v.status'
                  :cpntId='campos.p_pis_v.id'
                  :cpntClassDivField='campos.p_pis_v.classDivField'
                  :cpntNome='campos.p_pis_v.nome'
                  :cpntValue='campos.p_pis_v.value'
                  :cpntAutoComplete='campos.p_pis_v.autocomplete'
                  :cpntMask='campos.p_pis_v.mask'
                  :cpntOptionInicialNome='campos.p_pis_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_pis_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_pis_v.disabled === true'
                  :cpntMostrar='campos.p_pis_v.mostrar'
                  :cpntExplica='campos.p_pis_v.explica'
                  :cpntAutoFocus='campos.p_pis_v.autofocus'
                  :cpntMensagem='campos.p_pis_v.mensagem'
                  :cpntMensagemTipo='campos.p_pis_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_pis_v.placeholder'
                  :cpntPosicionar='campos.p_pis_v.posicionar'
                  :cpntOnChange='campos.p_pis_v.onChange'
                  :cpntOnBlur='campos.p_pis_v.onBlur'
                  ref='p_pis_v'
                ></App-Input>
              </div>
            </div>
          </div>
        </div>

        <div v-show="abaVal === 'cofins'">
          <div class="titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            COFINS
          </div>
          <div class="quadrado">
            <div>
              <div class="dem-edi-pro-tab-item-editar--p_cofins_cst" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.cofins_cst) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time"
                  :cpntStatus='campos.p_cofins_cst.status'
                  :cpntId='campos.p_cofins_cst.id'
                  :cpntTabIndex='campos.p_cofins_cst.tabIndex'
                  :cpntNome='campos.p_cofins_cst.nome'
                  :cpntValue='campos.p_cofins_cst.value'
                  :cpntMensagem='campos.p_cofins_cst.mensagem'
                  :cpntMensagemTipo='campos.p_cofins_cst.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_cofins_cst.disabled === true'
                  :cpntMostrar='campos.p_cofins_cst.mostrar'
                  :cpntExplica='campos.p_cofins_cst.explica'
                  :cpntPlaceholder='campos.p_cofins_cst.placeholder'
                  :cpntValueRef='campos.p_cofins_cst.valueRef'
                  :cpntRouter='campos.p_cofins_cst.router'
                  :cpntField='campos.p_cofins_cst.field'
                  :cpntWhere='campos.p_cofins_cst.where'
                  :cpntAddButForm='campos.p_cofins_cst.addButForm'
                  :cpntKeyMostra='campos.p_cofins_cst.keyMostra'
                  :cpntTipoOrder='campos.p_cofins_cst.tipoOrder'
                  :cpntOrder='campos.p_cofins_cst.order'
                  :cpntOptions='campos.p_cofins_cst.options'
                  :cpntOptionInicialNome='campos.p_cofins_cst.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_cofins_cst.optionInicialValue'
                  :cpntKeyValue='campos.p_cofins_cst.keyValue'
                  :cpntSearchMinimo='campos.p_cofins_cst.searchMinimo'
                  :cpntMask='campos.p_cofins_cst.mask'

                  :cpntOnBuscarOptions='campos.p_cofins_cst.onBuscarOptions'
                  :cpntOnChange='campos.p_cofins_cst.onChange'
                  :cpntOnBlur='campos.p_cofins_cst.onBlur'
                  :cpntOnRealizaBusca='campos.p_cofins_cst.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_cofins_cst.onKeyPressEnter'
                  ref="p_cofins_cst"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_cofins_cst.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.cofins_cst }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_cofins_bc_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_cofins_bc_v.status'
                  :cpntId='campos.p_cofins_bc_v.id'
                  :cpntClassDivField='campos.p_cofins_bc_v.classDivField'
                  :cpntNome='campos.p_cofins_bc_v.nome'
                  :cpntValue='campos.p_cofins_bc_v.value'
                  :cpntAutoComplete='campos.p_cofins_bc_v.autocomplete'
                  :cpntMask='campos.p_cofins_bc_v.mask'
                  :cpntOptionInicialNome='campos.p_cofins_bc_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_cofins_bc_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_cofins_bc_v.disabled === true'
                  :cpntMostrar='campos.p_cofins_bc_v.mostrar'
                  :cpntExplica='campos.p_cofins_bc_v.explica'
                  :cpntAutoFocus='campos.p_cofins_bc_v.autofocus'
                  :cpntMensagem='campos.p_cofins_bc_v.mensagem'
                  :cpntMensagemTipo='campos.p_cofins_bc_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_cofins_bc_v.placeholder'
                  :cpntPosicionar='campos.p_cofins_bc_v.posicionar'
                  :cpntOnChange='campos.p_cofins_bc_v.onChange'
                  :cpntOnBlur='campos.p_cofins_bc_v.onBlur'
                  ref='p_cofins_bc_v'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_cofins_a" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.cofins_a) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_cofins_a.status'
                  :cpntId='campos.p_cofins_a.id'
                  :cpntClassDivField='campos.p_cofins_a.classDivField'
                  :cpntNome='campos.p_cofins_a.nome'
                  :cpntValue='campos.p_cofins_a.value'
                  :cpntAutoComplete='campos.p_cofins_a.autocomplete'
                  :cpntMask='campos.p_cofins_a.mask'
                  :cpntOptionInicialNome='campos.p_cofins_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_cofins_a.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_cofins_a.disabled === true'
                  :cpntMostrar='campos.p_cofins_a.mostrar'
                  :cpntExplica='campos.p_cofins_a.explica'
                  :cpntAutoFocus='campos.p_cofins_a.autofocus'
                  :cpntMensagem='campos.p_cofins_a.mensagem'
                  :cpntMensagemTipo='campos.p_cofins_a.mensagemTipo'
                  :cpntPlaceholder='campos.p_cofins_a.placeholder'
                  :cpntPosicionar='campos.p_cofins_a.posicionar'
                  :cpntOnChange='campos.p_cofins_a.onChange'
                  :cpntOnBlur='campos.p_cofins_a.onBlur'
                  ref='p_cofins_a'
                ></App-Input>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_cofins_a.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.cofins_a }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_cofins_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_cofins_v.status'
                  :cpntId='campos.p_cofins_v.id'
                  :cpntClassDivField='campos.p_cofins_v.classDivField'
                  :cpntNome='campos.p_cofins_v.nome'
                  :cpntValue='campos.p_cofins_v.value'
                  :cpntAutoComplete='campos.p_cofins_v.autocomplete'
                  :cpntMask='campos.p_cofins_v.mask'
                  :cpntOptionInicialNome='campos.p_cofins_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_cofins_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_cofins_v.disabled === true'
                  :cpntMostrar='campos.p_cofins_v.mostrar'
                  :cpntAutoFocus='campos.p_cofins_v.autofocus'
                  :cpntMensagem='campos.p_cofins_v.mensagem'
                  :cpntExplica='campos.p_cofins_v.explica'
                  :cpntMensagemTipo='campos.p_cofins_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_cofins_v.placeholder'
                  :cpntPosicionar='campos.p_cofins_v.posicionar'
                  :cpntOnChange='campos.p_cofins_v.onChange'
                  :cpntOnBlur='campos.p_cofins_v.onBlur'
                  ref='p_cofins_v'
                ></App-Input>
              </div>
            </div>
          </div>
        </div>

        <div v-show="abaVal === 'ipi'">
          <div class="titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            IPI
          </div>
          <div class="quadrado">
            <div>
              <div class="dem-edi-pro-tab-item-editar--p_ipi_cst" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.ipi_cst) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time"
                  :cpntStatus='campos.p_ipi_cst.status'
                  :cpntId='campos.p_ipi_cst.id'
                  :cpntTabIndex='campos.p_ipi_cst.tabIndex'
                  :cpntNome='campos.p_ipi_cst.nome'
                  :cpntValue='campos.p_ipi_cst.value'
                  :cpntMensagem='campos.p_ipi_cst.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_cst.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_ipi_cst.disabled === true'
                  :cpntMostrar='campos.p_ipi_cst.mostrar'
                  :cpntExplica='campos.p_ipi_cst.explica'
                  :cpntPlaceholder='campos.p_ipi_cst.placeholder'
                  :cpntValueRef='campos.p_ipi_cst.valueRef'
                  :cpntRouter='campos.p_ipi_cst.router'
                  :cpntField='campos.p_ipi_cst.field'
                  :cpntWhere='campos.p_ipi_cst.where'
                  :cpntAddButForm='campos.p_ipi_cst.addButForm'
                  :cpntKeyMostra='campos.p_ipi_cst.keyMostra'
                  :cpntTipoOrder='campos.p_ipi_cst.tipoOrder'
                  :cpntOrder='campos.p_ipi_cst.order'
                  :cpntOptions='campos.p_ipi_cst.options'
                  :cpntOptionInicialNome='campos.p_ipi_cst.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_cst.optionInicialValue'
                  :cpntKeyValue='campos.p_ipi_cst.keyValue'
                  :cpntSearchMinimo='campos.p_ipi_cst.searchMinimo'
                  :cpntMask='campos.p_ipi_cst.mask'

                  :cpntOnBuscarOptions='campos.p_ipi_cst.onBuscarOptions'
                  :cpntOnChange='campos.p_ipi_cst.onChange'
                  :cpntOnBlur='campos.p_ipi_cst.onBlur'
                  :cpntOnRealizaBusca='campos.p_ipi_cst.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_ipi_cst.onKeyPressEnter'
                  ref="p_ipi_cst"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_ipi_cst.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.ipi_cst }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_ipi_bc_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_ipi_bc_v.status'
                  :cpntId='campos.p_ipi_bc_v.id'
                  :cpntClassDivField='campos.p_ipi_bc_v.classDivField'
                  :cpntNome='campos.p_ipi_bc_v.nome'
                  :cpntValue='campos.p_ipi_bc_v.value'
                  :cpntAutoComplete='campos.p_ipi_bc_v.autocomplete'
                  :cpntMask='campos.p_ipi_bc_v.mask'
                  :cpntOptionInicialNome='campos.p_ipi_bc_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_bc_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_ipi_bc_v.disabled === true'
                  :cpntMostrar='campos.p_ipi_bc_v.mostrar'
                  :cpntExplica='campos.p_ipi_bc_v.explica'
                  :cpntAutoFocus='campos.p_ipi_bc_v.autofocus'
                  :cpntMensagem='campos.p_ipi_bc_v.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_bc_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_ipi_bc_v.placeholder'
                  :cpntPosicionar='campos.p_ipi_bc_v.posicionar'
                  :cpntOnChange='campos.p_ipi_bc_v.onChange'
                  :cpntOnBlur='campos.p_ipi_bc_v.onBlur'
                  ref='p_ipi_bc_v'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_ipi_a" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.ipi_a) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_ipi_a.status'
                  :cpntId='campos.p_ipi_a.id'
                  :cpntClassDivField='campos.p_ipi_a.classDivField'
                  :cpntNome='campos.p_ipi_a.nome'
                  :cpntValue='campos.p_ipi_a.value'
                  :cpntAutoComplete='campos.p_ipi_a.autocomplete'
                  :cpntMask='campos.p_ipi_a.mask'
                  :cpntOptionInicialNome='campos.p_ipi_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_a.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_ipi_a.disabled === true'
                  :cpntMostrar='campos.p_ipi_a.mostrar'
                  :cpntExplica='campos.p_ipi_a.explica'
                  :cpntAutoFocus='campos.p_ipi_a.autofocus'
                  :cpntMensagem='campos.p_ipi_a.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_a.mensagemTipo'
                  :cpntPlaceholder='campos.p_ipi_a.placeholder'
                  :cpntPosicionar='campos.p_ipi_a.posicionar'
                  :cpntOnChange='campos.p_ipi_a.onChange'
                  :cpntOnBlur='campos.p_ipi_a.onBlur'
                  ref='p_ipi_a'
                ></App-Input>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_ipi_a.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.ipi_a }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_ipi_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_ipi_v.status'
                  :cpntId='campos.p_ipi_v.id'
                  :cpntClassDivField='campos.p_ipi_v.classDivField'
                  :cpntNome='campos.p_ipi_v.nome'
                  :cpntValue='campos.p_ipi_v.value'
                  :cpntAutoComplete='campos.p_ipi_v.autocomplete'
                  :cpntMask='campos.p_ipi_v.mask'
                  :cpntOptionInicialNome='campos.p_ipi_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_ipi_v.disabled === true'
                  :cpntMostrar='campos.p_ipi_v.mostrar'
                  :cpntAutoFocus='campos.p_ipi_v.autofocus'
                  :cpntMensagem='campos.p_ipi_v.mensagem'
                  :cpntExplica='campos.p_ipi_v.explica'
                  :cpntMensagemTipo='campos.p_ipi_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_ipi_v.placeholder'
                  :cpntPosicionar='campos.p_ipi_v.posicionar'
                  :cpntOnChange='campos.p_ipi_v.onChange'
                  :cpntOnBlur='campos.p_ipi_v.onBlur'
                  ref='p_ipi_v'
                ></App-Input>
              </div>
            </div>

            <div>
              <div class="dem-edi-pro-tab-item-editar--p_ipi_enq" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.ipi_enq) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time"
                  :cpntStatus='campos.p_ipi_enq.status'
                  :cpntId='campos.p_ipi_enq.id'
                  :cpntTabIndex='campos.p_ipi_enq.tabIndex'
                  :cpntNome='campos.p_ipi_enq.nome'
                  :cpntValue='campos.p_ipi_enq.value'
                  :cpntMensagem='campos.p_ipi_enq.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_enq.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_ipi_enq.disabled === true'
                  :cpntMostrar='campos.p_ipi_enq.mostrar'
                  :cpntExplica='campos.p_ipi_enq.explica'
                  :cpntPlaceholder='campos.p_ipi_enq.placeholder'
                  :cpntValueRef='campos.p_ipi_enq.valueRef'
                  :cpntRouter='campos.p_ipi_enq.router'
                  :cpntField='campos.p_ipi_enq.field'
                  :cpntWhere='campos.p_ipi_enq.where'
                  :cpntAddButForm='campos.p_ipi_enq.addButForm'
                  :cpntKeyMostra='campos.p_ipi_enq.keyMostra'
                  :cpntTipoOrder='campos.p_ipi_enq.tipoOrder'
                  :cpntOrder='campos.p_ipi_enq.order'
                  :cpntOptions='campos.p_ipi_enq.options'
                  :cpntOptionInicialNome='campos.p_ipi_enq.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_enq.optionInicialValue'
                  :cpntKeyValue='campos.p_ipi_enq.keyValue'
                  :cpntSearchMinimo='campos.p_ipi_enq.searchMinimo'
                  :cpntMask='campos.p_ipi_enq.mask'

                  :cpntOnBuscarOptions='campos.p_ipi_enq.onBuscarOptions'
                  :cpntOnChange='campos.p_ipi_enq.onChange'
                  :cpntOnBlur='campos.p_ipi_enq.onBlur'
                  :cpntOnRealizaBusca='campos.p_ipi_enq.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_ipi_enq.onKeyPressEnter'
                  ref="p_ipi_enq"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_ipi_enq.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.ipi_enq }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_ipi_selo" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.ipi_selo) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Select :data-time="time"
                  :cpntStatus='campos.p_ipi_selo.status'
                  :cpntId='campos.p_ipi_selo.id'
                  :cpntTabIndex='campos.p_ipi_selo.tabIndex'
                  :cpntNome='campos.p_ipi_selo.nome'
                  :cpntValue='campos.p_ipi_selo.value'
                  :cpntMensagem='campos.p_ipi_selo.mensagem'
                  :cpntMensagemTipo='campos.p_ipi_selo.mensagemTipo'
                  :cpntDisabled='cpntEditar === false || campos.p_ipi_selo.disabled === true'
                  :cpntMostrar='campos.p_ipi_selo.mostrar'
                  :cpntExplica='campos.p_ipi_selo.explica'
                  :cpntPlaceholder='campos.p_ipi_selo.placeholder'
                  :cpntValueRef='campos.p_ipi_selo.valueRef'
                  :cpntRouter='campos.p_ipi_selo.router'
                  :cpntField='campos.p_ipi_selo.field'
                  :cpntWhere='campos.p_ipi_selo.where'
                  :cpntAddButForm='campos.p_ipi_selo.addButForm'
                  :cpntKeyMostra='campos.p_ipi_selo.keyMostra'
                  :cpntTipoOrder='campos.p_ipi_selo.tipoOrder'
                  :cpntOrder='campos.p_ipi_selo.order'
                  :cpntOptions='campos.p_ipi_selo.options'
                  :cpntOptionInicialNome='campos.p_ipi_selo.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_ipi_selo.optionInicialValue'
                  :cpntKeyValue='campos.p_ipi_selo.keyValue'
                  :cpntSearchMinimo='campos.p_ipi_selo.searchMinimo'
                  :cpntMask='campos.p_ipi_selo.mask'

                  :cpntOnBuscarOptions='campos.p_ipi_selo.onBuscarOptions'
                  :cpntOnChange='campos.p_ipi_selo.onChange'
                  :cpntOnBlur='campos.p_ipi_selo.onBlur'
                  :cpntOnRealizaBusca='campos.p_ipi_selo.onRealizaBusca'
                  :cpntOnKeyPressEnter='campos.p_ipi_selo.onKeyPressEnter'
                  ref="p_ipi_selo"
                ></App-Select>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_ipi_selo.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.ipi_selo }"
                  ></App-Icone>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="abaVal === 'tributos'">
          <div class="titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            Estimativa de Impostos Federais
          </div>
          <div class="quadrado">
            <div>
              <div class="dem-edi-pro-tab-item-editar--p_fed_bc_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_fed_bc_v.status'
                  :cpntId='campos.p_fed_bc_v.id'
                  :cpntClassDivField='campos.p_fed_bc_v.classDivField'
                  :cpntNome='campos.p_fed_bc_v.nome'
                  :cpntValue='campos.p_fed_bc_v.value'
                  :cpntAutoComplete='campos.p_fed_bc_v.autocomplete'
                  :cpntMask='campos.p_fed_bc_v.mask'
                  :cpntOptionInicialNome='campos.p_fed_bc_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_fed_bc_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_fed_bc_v.disabled === true'
                  :cpntMostrar='campos.p_fed_bc_v.mostrar'
                  :cpntExplica='campos.p_fed_bc_v.explica'
                  :cpntAutoFocus='campos.p_fed_bc_v.autofocus'
                  :cpntMensagem='campos.p_fed_bc_v.mensagem'
                  :cpntMensagemTipo='campos.p_fed_bc_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_fed_bc_v.placeholder'
                  :cpntPosicionar='campos.p_fed_bc_v.posicionar'
                  :cpntOnChange='campos.p_fed_bc_v.onChange'
                  :cpntOnBlur='campos.p_fed_bc_v.onBlur'
                  ref='p_fed_bc_v'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_fed_a" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.fed_a) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_fed_a.status'
                  :cpntId='campos.p_fed_a.id'
                  :cpntClassDivField='campos.p_fed_a.classDivField'
                  :cpntNome='campos.p_fed_a.nome'
                  :cpntValue='campos.p_fed_a.value'
                  :cpntAutoComplete='campos.p_fed_a.autocomplete'
                  :cpntMask='campos.p_fed_a.mask'
                  :cpntOptionInicialNome='campos.p_fed_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_fed_a.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_fed_a.disabled === true'
                  :cpntMostrar='campos.p_fed_a.mostrar'
                  :cpntExplica='campos.p_fed_a.explica'
                  :cpntAutoFocus='campos.p_fed_a.autofocus'
                  :cpntMensagem='campos.p_fed_a.mensagem'
                  :cpntMensagemTipo='campos.p_fed_a.mensagemTipo'
                  :cpntPlaceholder='campos.p_fed_a.placeholder'
                  :cpntPosicionar='campos.p_fed_a.posicionar'
                  :cpntOnChange='campos.p_fed_a.onChange'
                  :cpntOnBlur='campos.p_fed_a.onBlur'
                  ref='p_fed_a'
                ></App-Input>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_fed_a.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.fed_a }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_fed_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_fed_v.status'
                  :cpntId='campos.p_fed_v.id'
                  :cpntClassDivField='campos.p_fed_v.classDivField'
                  :cpntNome='campos.p_fed_v.nome'
                  :cpntValue='campos.p_fed_v.value'
                  :cpntAutoComplete='campos.p_fed_v.autocomplete'
                  :cpntMask='campos.p_fed_v.mask'
                  :cpntOptionInicialNome='campos.p_fed_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_fed_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_fed_v.disabled === true'
                  :cpntMostrar='campos.p_fed_v.mostrar'
                  :cpntAutoFocus='campos.p_fed_v.autofocus'
                  :cpntMensagem='campos.p_fed_v.mensagem'
                  :cpntExplica='campos.p_fed_v.explica'
                  :cpntMensagemTipo='campos.p_fed_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_fed_v.placeholder'
                  :cpntPosicionar='campos.p_fed_v.posicionar'
                  :cpntOnChange='campos.p_fed_v.onChange'
                  :cpntOnBlur='campos.p_fed_v.onBlur'
                  ref='p_fed_v'
                ></App-Input>
              </div>
            </div>
          </div>

          <div class="titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            Estimativa de Impostos Estaduais
          </div>
          <div class="quadrado">
            <div>
              <div class="dem-edi-pro-tab-item-editar--p_est_bc_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_est_bc_v.status'
                  :cpntId='campos.p_est_bc_v.id'
                  :cpntClassDivField='campos.p_est_bc_v.classDivField'
                  :cpntNome='campos.p_est_bc_v.nome'
                  :cpntValue='campos.p_est_bc_v.value'
                  :cpntAutoComplete='campos.p_est_bc_v.autocomplete'
                  :cpntMask='campos.p_est_bc_v.mask'
                  :cpntOptionInicialNome='campos.p_est_bc_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_est_bc_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_est_bc_v.disabled === true'
                  :cpntMostrar='campos.p_est_bc_v.mostrar'
                  :cpntExplica='campos.p_est_bc_v.explica'
                  :cpntAutoFocus='campos.p_est_bc_v.autofocus'
                  :cpntMensagem='campos.p_est_bc_v.mensagem'
                  :cpntMensagemTipo='campos.p_est_bc_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_est_bc_v.placeholder'
                  :cpntPosicionar='campos.p_est_bc_v.posicionar'
                  :cpntOnChange='campos.p_est_bc_v.onChange'
                  :cpntOnBlur='campos.p_est_bc_v.onBlur'
                  ref='p_est_bc_v'
                ></App-Input>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_est_a" :class="([ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1 && [ '', null, undefined ].indexOf(dados.virtual_check_caso.diff.est_a) === -1) ? 'mostrar-alerta-campo' : ''">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_est_a.status'
                  :cpntId='campos.p_est_a.id'
                  :cpntClassDivField='campos.p_est_a.classDivField'
                  :cpntNome='campos.p_est_a.nome'
                  :cpntValue='campos.p_est_a.value'
                  :cpntAutoComplete='campos.p_est_a.autocomplete'
                  :cpntMask='campos.p_est_a.mask'
                  :cpntOptionInicialNome='campos.p_est_a.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_est_a.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_est_a.disabled === true'
                  :cpntMostrar='campos.p_est_a.mostrar'
                  :cpntExplica='campos.p_est_a.explica'
                  :cpntAutoFocus='campos.p_est_a.autofocus'
                  :cpntMensagem='campos.p_est_a.mensagem'
                  :cpntMensagemTipo='campos.p_est_a.mensagemTipo'
                  :cpntPlaceholder='campos.p_est_a.placeholder'
                  :cpntPosicionar='campos.p_est_a.posicionar'
                  :cpntOnChange='campos.p_est_a.onChange'
                  :cpntOnBlur='campos.p_est_a.onBlur'
                  ref='p_est_a'
                ></App-Input>
                <div class="alerta-campo" v-if="[ '', null, undefined ].indexOf(dados.virtual_check_caso) === -1">
                  <App-Icone
                  :cpntTipo='"alerta-amarelo"'
                  :cpntExplica="{ mensagem: 'Foi encontrado diferença no campo ' + campos.p_est_a.nome + ': <br/><br/>' + dados.virtual_check_caso.diff.est_a }"
                  ></App-Icone>
                </div>
              </div>

              <div class="dem-edi-pro-tab-item-editar--p_est_v">
                <App-Input :data-time="time"
                  :cpntStatus='campos.p_est_v.status'
                  :cpntId='campos.p_est_v.id'
                  :cpntClassDivField='campos.p_est_v.classDivField'
                  :cpntNome='campos.p_est_v.nome'
                  :cpntValue='campos.p_est_v.value'
                  :cpntAutoComplete='campos.p_est_v.autocomplete'
                  :cpntMask='campos.p_est_v.mask'
                  :cpntOptionInicialNome='campos.p_est_v.optionInicialNome'
                  :cpntOptionInicialValue='campos.p_est_v.optionInicialValue'
                  :cpntDisabled='cpntEditar === false || campos.p_est_v.disabled === true'
                  :cpntMostrar='campos.p_est_v.mostrar'
                  :cpntAutoFocus='campos.p_est_v.autofocus'
                  :cpntMensagem='campos.p_est_v.mensagem'
                  :cpntExplica='campos.p_est_v.explica'
                  :cpntMensagemTipo='campos.p_est_v.mensagemTipo'
                  :cpntPlaceholder='campos.p_est_v.placeholder'
                  :cpntPosicionar='campos.p_est_v.posicionar'
                  :cpntOnChange='campos.p_est_v.onChange'
                  :cpntOnBlur='campos.p_est_v.onBlur'
                  ref='p_est_v'
                ></App-Input>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </template>

  <template slot='rodape' v-if="cpntEditar === true">
    <div class="dem-edi-pro-tab-item-editar-botoes">
      <App-Button
        :cpntStatus='botoes.cancelar.status' 
        :cpntId='botoes.cancelar.id' 
        :cpntTexto='botoes.cancelar.texto' 
        :cpntClass='botoes.cancelar.class'
        :cpntMostrar='botoes.cancelar.mostrar'
        :cpntTabIndex='botoes.cancelar.tabIndex'
        @onClick='botoes.cancelar.onClick'
      ></App-Button>

      <App-Button
        :cpntStatus='botoes.salvar.status' 
        :cpntId='botoes.salvar.id' 
        :cpntTexto='botoes.salvar.texto' 
        :cpntClass='botoes.salvar.class'
        :cpntMostrar='botoes.salvar.mostrar'
        :cpntTabIndex='botoes.salvar.tabIndex'
        @onClick='botoes.salvar.onClick'
      ></App-Button>
    </div>
  </template>
</RF-Dialog>
</template>

<style scoped>
.dem-edi-pro-tab-item-botoes > button {
  width: 28px;
  height: 25px;
  padding: 0px;
  margin: 0px 2px;
}
.dem-edi-pro-tab-item-editar {
  padding-right: 10px;
  min-height: 240px;
}
  .dem-edi-pro-tab-item-editar > div > div > div:first-child {
    padding-top: 10px;
  }
  .dem-edi-pro-tab-item-editar > div > div > div:not(:first-child) {
    padding-top: 25px;
  }
  .dem-edi-pro-tab-item-editar > div > div:not(:first-child) > div > div {
    vertical-align: top;
    display: inline-block;
  }
  .titulo {
    margin-top: 5px;
    font-weight: bold;
    margin-bottom: -2px;
  }
  .quadrado {
    background: #f9f9f9;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px 10px 10px 10px;
  }

.dem-edi-pro-tab-item-editar--p_id_caso {
  width: 200px;
  margin-right: 10px;
  margin-bottom: 10px;
  vertical-align: top;
  display: inline-block;
}
.dem-edi-pro-tab-item-editar--p_id_cfop {
  width: calc(100% - 200px - 10px);
  vertical-align: top;
  display: inline-block;
}
.dem-edi-pro-tab-item-editar--p_icms_origem {
  width: 200px;
  margin-right: 10px;
}
.dem-edi-pro-tab-item-editar--p_icms_cst {
  width: calc(100% - 200px - 10px);
}
.dem-edi-pro-tab-item-editar--p_pis_cst,
.dem-edi-pro-tab-item-editar--p_cofins_cst,
.dem-edi-pro-tab-item-editar--p_ipi_cst {
  width: 200px;
}
.dem-edi-pro-tab-item-editar--p_pis_bc_v,
.dem-edi-pro-tab-item-editar--p_pis_a,
.dem-edi-pro-tab-item-editar--p_pis_v,
.dem-edi-pro-tab-item-editar--p_cofins_bc_v,
.dem-edi-pro-tab-item-editar--p_cofins_a,
.dem-edi-pro-tab-item-editar--p_cofins_v,
.dem-edi-pro-tab-item-editar--p_ipi_bc_v,
.dem-edi-pro-tab-item-editar--p_ipi_a,
.dem-edi-pro-tab-item-editar--p_ipi_v {
  width: calc(((100% - 200px) / 3) - 10px);
}

.dem-edi-pro-tab-item-editar--p_pis_cst,
.dem-edi-pro-tab-item-editar--p_pis_bc_v,
.dem-edi-pro-tab-item-editar--p_pis_a,
.dem-edi-pro-tab-item-editar--p_cofins_cst,
.dem-edi-pro-tab-item-editar--p_cofins_bc_v,
.dem-edi-pro-tab-item-editar--p_cofins_a,
.dem-edi-pro-tab-item-editar--p_ipi_cst,
.dem-edi-pro-tab-item-editar--p_ipi_bc_v,
.dem-edi-pro-tab-item-editar--p_ipi_a,
.dem-edi-pro-tab-item-editar--p_ipi_enq {
  margin-right: 10px;
}

.dem-edi-pro-tab-item-editar--p_icms_mod_bc,
.dem-edi-pro-tab-item-editar--p_icms_st_bc_mod {
  width: 120px;
}
.dem-edi-pro-tab-item-editar--p_icms_bc_v,
.dem-edi-pro-tab-item-editar--p_icms_a,
.dem-edi-pro-tab-item-editar--p_icms_bc_p_r,
.dem-edi-pro-tab-item-editar--p_icms_bc_p_r_c,
.dem-edi-pro-tab-item-editar--p_icms_v,

.dem-edi-pro-tab-item-editar--p_icms_mva_p,
.dem-edi-pro-tab-item-editar--p_icms_st_bc_v,
.dem-edi-pro-tab-item-editar--p_icms_st_a,
.dem-edi-pro-tab-item-editar--p_icms_bc_st_p_r,
.dem-edi-pro-tab-item-editar--p_icms_st_v {
  width: calc(((100% - 120px) / 5) - 10px);
  margin-left: 10px;
}

.dem-edi-pro-tab-item-editar--p_ipi_selo,
.dem-edi-pro-tab-item-editar--p_ipi_enq {
  width: calc(50% - 5px);
}

.dem-edi-pro-tab-item-editar--item,
.dem-edi-pro-tab-item-editar--qtde,
.dem-edi-pro-tab-item-editar--valor_uni,
.dem-edi-pro-tab-item-editar--valor_fre,
.dem-edi-pro-tab-item-editar--valor_seg,
.dem-edi-pro-tab-item-editar--valor_des,
.dem-edi-pro-tab-item-editar--valor_oda,
.dem-edi-pro-tab-item-editar--p_fed_bc_v,
.dem-edi-pro-tab-item-editar--p_fed_a,
.dem-edi-pro-tab-item-editar--p_est_bc_v,
.dem-edi-pro-tab-item-editar--p_est_a,
.dem-edi-pro-tab-item-editar--cms_com_id,
.dem-edi-pro-tab-item-editar--xPed {
  margin-right: 10px;
}

.dem-edi-pro-tab-item-editar--item {
  width: calc((100% - 370px) - 10px);
}
.dem-edi-pro-tab-item-editar--qtde,
.dem-edi-pro-tab-item-editar--valor_uni,
.dem-edi-pro-tab-item-editar--valor_tot {
  width: calc((360px / 3) - (10px / 3));
}
.dem-edi-pro-tab-item-editar--valor_fre,
.dem-edi-pro-tab-item-editar--valor_seg,
.dem-edi-pro-tab-item-editar--valor_des,
.dem-edi-pro-tab-item-editar--valor_oda,
.dem-edi-pro-tab-item-editar--sub_total {
  width: calc((100% / 5) - (40px / 5));
}
.dem-edi-pro-tab-item-editar--p_fed_bc_v,
.dem-edi-pro-tab-item-editar--p_fed_a,
.dem-edi-pro-tab-item-editar--p_fed_v,
.dem-edi-pro-tab-item-editar--p_est_bc_v,
.dem-edi-pro-tab-item-editar--p_est_a,
.dem-edi-pro-tab-item-editar--p_est_v,
.dem-edi-pro-tab-item-editar--cms_com_id,
.dem-edi-pro-tab-item-editar--xPed,
.dem-edi-pro-tab-item-editar--id_pco_status {
  width: calc((100% / 3) - (20px / 3));
}

.dem-edi-pro-tab-item-editar-botoes {
  text-align: right;
}
  .dem-edi-pro-tab-item-editar-botoes > button:not(:first-child) {
    margin-left: 5px;
  }

.dem-edi-pro-tab-item-editar--cms_com_id,
.dem-edi-pro-tab-item-editar--id_pco_status {
  display: inline-block;
  margin-top: -16px;
}
  .dem-edi-pro-tab-item-editar--cms_com_id > .titulo,
  .dem-edi-pro-tab-item-editar--id_pco_status > .titulo {
    height: 18px;
    font-weight: normal;
  }
  .dem-edi-pro-tab-item-editar--cms_com_id > .conteudo,
  .dem-edi-pro-tab-item-editar--id_pco_status > .conteudo {
    width: 100%;
    height: 30px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 3px;
    text-align: center;
    line-height: 22px;
  }
  .dem-edi-pro-tab-item-editar--cms_com_id > .conteudo:hover,
  .dem-edi-pro-tab-item-editar--id_pco_status > .conteudo:hover {
    text-decoration: underline;
  }
  .dem-edi-pro-tab-item-editar--id_pco_status > .conteudo {
    padding: 0px;
  }
    .dem-edi-pro-tab-item-editar--id_pco_status > .conteudo > table {
      width: 100%;
      height: 100%;
    }

  .alerta-campo {
    display: none;
    margin-left: 2px;
    margin-top: 4px;
  }

  .mostrar-alerta-campo > .cpnt-app-campo {
    width: calc(100% - 22px);
  }
    .mostrar-alerta-campo > .alerta-campo {
      display: inline-block;
    }
</style>

<style>
.dem-edi-pro-tab-item-editar--item > .com-new-option {
  width: 100% !important;
}
  .dem-edi-pro-tab-item-editar--item > .com-new-option ~ button {
    display: none;
  }
  .dem-edi-pro-tab-item-editar--item > .com-new-option > div > input {
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
  }

   .dem-edi-pro-tab-item-editar--id_pco_status > .titulo {
     margin-top: 0px !important;
   }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntItemId: {
        required: true
      },
      cpntDados: {
        required: false
      },
      cpntPDocNFEmitida: {
        required: false
      },
      cpntPDocTp: {
        required: false
      },
      cpntIdCon: {
        required: false
      },
      cpntIdConUF: {
        required: false
      },
      cpntEditar: {
        required: false,
        default: function () {
          return true
        }
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        dados: null,
        abaVet: {},
        abaVal: '',
        campos: {
          item: {
            id: 'dem-edi-pro-tab-item-editar--item',
            status: '',
            nome: 'Produto (DIGITE e SELECIONE)',
            router: '/produto/get',
            method: 'POST',
            field: { id: null, codigo: null, cod_barra: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } }, valor_ven: null, id_pco_status: { j: { nome: null } } },
            fieldVirtual: [],
            where: 'dem-edi-pro',
            keyValue: 'id',
            keyMostra: [ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo produto' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.demEdiProFormOnNovoProduto
            },
            apiEnv: 'id_pro',
            value: '',
            valueIni: '',
            valueRef: '',
            mostrar: true,
            disabled: true,
            onRealizaBusca: this.demEdiProFormOnRealizarBusca,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          qtde: {
            id: 'dem-edi-pro-tab-item-editar--qtde',
            status: '',
            nome: 'Quantidade',
            mask: 'numero_decimal',
            apiEnv: 'qtde',
            value: '1,00',
            mostrar: true,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_uni: {
            id: 'dem-edi-pro-tab-item-editar--valor_uni',
            status: '',
            nome: 'Valor Unitário (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_uni',
            value: '0',
            valueIni: '0',
            mostrar: true,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_tot: {
            id: 'dem-edi-pro-tab-item-editar--valor_tot',
            status: '',
            nome: 'Valor Total (R$)',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            mostrar: true,
            disabled: true,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_fre: {
            id: 'dem-edi-pro-tab-item-editar--valor_fre',
            status: '',
            nome: 'Valor Frete (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_fre',
            value: '0',
            valueIni: '0',
            mostrar: true,
            explica: { mensagem: 'Insira o valor total do frete (este valor não será mutiplicado pela quantidade)' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_seg: {
            id: 'dem-edi-pro-tab-item-editar--valor_seg',
            status: '',
            nome: 'Valor Seguro (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_seg',
            value: '0',
            valueIni: '0',
            mostrar: true,
            explica: { mensagem: 'Insira o valor total do seguro (este valor não será mutiplicado pela quantidade)' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_des: {
            id: 'dem-edi-pro-tab-item-editar--valor_des',
            status: '',
            nome: 'Valor Desconto (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_des',
            value: '0',
            valueIni: '0',
            mostrar: true,
            explica: { mensagem: 'Insira o valor total do desconto (este valor não será mutiplicado pela quantidade)' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          valor_oda: {
            id: 'dem-edi-pro-tab-item-editar--valor_oda',
            status: '',
            nome: 'Valor O.D.A. (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_oda',
            value: '0',
            valueIni: '0',
            mostrar: true,
            explica: { mensagem: 'Insira o valor total de outras despesas acessórias (este valor não será mutiplicado pela quantidade)', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          sub_total: {
            id: 'dem-edi-pro-tab-item-editar--sub_total',
            status: '',
            nome: 'Subtotal (R$)',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            mostrar: true,
            disabled: true,
            explica: { mensagem: '(Quantidade * Valor Unitário) + Valor Frete + Valor Seguro - Valor Desconto + Valor Outras Despesas Acessorias', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          xPed: {
            id: 'dem-edi-pro-tab-item-editar--xPed',
            status: '',
            nome: 'Nº do Pedido',
            explica: { mensagem: 'Número do Pedido de Compra' },
            value: '',
            valueIni: '',
            apiEnv: 'xPed',
            mostrar: true,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_id_caso: {
            id: 'dem-edi-pro-tab-item-editar--p_id_caso',
            status: '',
            nome: 'Caso',
            keyValue: 'id',
            keyMostra: [ '_id_caso_nome' ],
            options: [],
            optionInicialNome: '',
            value: '',
            valueIni: '',
            mostrar: true,
            apiEnv: 'id_pro_sf',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCasos,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_id_cfop: {
            id: 'dem-edi-pro-tab-item-editar--p_id_cfop',
            status: '',
            nome: 'CFOP',
            keyValue: 'cfop',
            keyMostra: [ 'cfop', ' - ', 'descricao' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_id_cfop',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCFOP,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_origem: {
            id: 'dem-edi-pro-tab-item-editar--p_icms_origem',
            status: '',
            nome: 'Origem',
            keyValue: 'ref_icms_origem_id',
            keyMostra: [ 'ref_icms_origem_id', ' - ', 'ref_icms_origem_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_orig',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarIcmsOrigem,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_cst: {
            id: 'dem-edi-pro-tab-item-editar--p_icms_cst',
            status: '',
            keyValue: 'ref_icms_cst',
            keyMostra: [ 'ref_icms_cst', ' - ', 'ref_icms_cst_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_cst',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCstIcms,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_icms_mod_bc: {
            id: 'dem-edi-pro-tab-item-editar--p_icms_mod_bc',
            status: '',
            nome: 'Mod. BC',
            keyValue: 'ref_icms_mod_bc_id',
            keyMostra: [ 'ref_icms_mod_bc_id', ' - ', 'ref_icms_mod_bc_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            explica: { mensagem: 'Modalidade base de cálculo ICMS' },
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_mod_bc',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarIcmsModBc,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_bc_v: {
            id: 'dem-edi-pro-doc--p_icms_bc_v',
            status: '',
            nome: 'BC ICMS',
            mask: 'valorMoeda',
            explica: { mensagem: 'Base de cálculo ICMS' },
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_a: {
            id: 'dem-edi-pro-doc--p_icms_a',
            status: '',
            nome: '% ICMS',
            mask: 'valorMoeda',
            explica: { mensagem: 'Alíquota ICMS' },
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_bc_p_r: {
            id: 'dem-edi-pro-doc--p_icms_bc_p_r',
            status: '',
            nome: '% Redução',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_bc_p_r',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_v: {
            id: 'dem-edi-pro-doc--p_icms_v',
            status: '',
            nome: 'Valor ICMS',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_bc_p_r_c: {
            id: 'dem-edi-pro-tab-item-editar--p_icms_bc_p_r_c',
            status: '',
            nome: 'Sobre',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            optionInicialNome: '',
            mostrar: true,
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_bc_p_r_c',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarIcmsRedSobre,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_icms_st_bc_mod: {
            id: 'dem-edi-pro-tab-item-editar--p_icms_st_bc_mod',
            status: '',
            nome: 'Mod. BC ST',
            keyValue: 'ref_icms_mod_bc_st_id',
            keyMostra: [ 'ref_icms_mod_bc_st_id', ' - ', 'ref_icms_mod_bc_st_desc' ],
            options: [],
            optionInicialNome: 'Não aplicável',
            optionInicialValue: '-1',
            mostrar: true,
            explica: { mensagem: 'Modalidade base de cálculo ICMS Substituição Tributária' },
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_st_bc_mod',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarIcmsModBcSt,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_mva_p: {
            id: 'dem-edi-pro-doc--p_icms_mva_p',
            status: '',
            nome: 'MVA %',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            // disabled: true,
            apiEnv: 'p_icms_mva_p',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_st_bc_v: {
            id: 'dem-edi-pro-doc--p_icms_st_bc_v',
            status: '',
            nome: 'BC ICMS ST',
            mask: 'valorMoeda',
            explica: { mensagem: 'Base de cálculo ICMS Substituição Tributária' },
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_st_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_st_a: {
            id: 'dem-edi-pro-doc--p_icms_st_a',
            status: '',
            nome: '% ICMS ST',
            mask: 'valorMoeda',
            explica: { mensagem: 'Alíquota ICMS Substituição Tributária' },
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_st_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_bc_st_p_r: {
            id: 'dem-edi-pro-doc--p_icms_bc_st_p_r',
            status: '',
            nome: 'Redução ST %',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_bc_st_p_r',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_icms_st_v: {
            id: 'dem-edi-pro-doc--p_icms_st_v',
            status: '',
            nome: 'Valor ICMS ST',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_icms_st_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_pis_cst: {
            id: 'dem-edi-pro-tab-item-editar--p_pis_cst',
            status: '',
            nome: 'CST',
            keyValue: 'ref_pc_cst',
            keyMostra: [ 'ref_pc_cst', ' - ', 'ref_pc_cst_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_pis_cst',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCstPisCofins,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_pis_bc_v: {
            id: 'dem-edi-pro-doc--p_pis_bc_v',
            status: '',
            nome: 'Base de cálculo',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            // disabled: true,
            apiEnv: 'p_pis_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_pis_a: {
            id: 'dem-edi-pro-doc--p_pis_a',
            status: '',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            // disabled: true,
            apiEnv: 'p_pis_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_pis_v: {
            id: 'dem-edi-pro-doc--p_pis_v',
            status: '',
            nome: 'Valor',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            // disabled: true,
            apiEnv: 'p_pis_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_cofins_cst: {
            id: 'dem-edi-pro-tab-item-editar--p_cofins_cst',
            status: '',
            nome: 'CST',
            keyValue: 'ref_pc_cst',
            keyMostra: [ 'ref_pc_cst', ' - ', 'ref_pc_cst_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_cofins_cst',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCstPisCofins,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_cofins_bc_v: {
            id: 'dem-edi-pro-doc--p_cofins_bc_v',
            status: '',
            nome: 'Base de cálculo',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            apiEnv: 'p_cofins_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_cofins_a: {
            id: 'dem-edi-pro-doc--p_cofins_a',
            status: '',
            value: '0',
            valueIni: '0',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            // disabled: true,
            apiEnv: 'p_cofins_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_cofins_v: {
            id: 'dem-edi-pro-doc--p_cofins_v',
            status: '',
            nome: 'Valor',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            // disabled: true,
            apiEnv: 'p_cofins_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_ipi_cst: {
            id: 'dem-edi-pro-tab-item-editar--p_ipi_cst',
            status: '',
            nome: 'CST',
            keyValue: 'ref_ipi_cst',
            keyMostra: [ 'ref_ipi_cst', ' - ', 'ref_ipi_cst_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_ipi_cst',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarCstIpi,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_ipi_bc_v: {
            id: 'dem-edi-pro-doc--p_ipi_bc_v',
            status: '',
            value: '0',
            valueIni: '0',
            nome: 'Base de cálculo',
            mask: 'valorMoeda',
            // disabled: true,
            apiEnv: 'p_ipi_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_ipi_a: {
            id: 'dem-edi-pro-doc--p_ipi_a',
            status: '',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_ipi_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_ipi_v: {
            id: 'dem-edi-pro-doc--p_ipi_v',
            status: '',
            nome: 'Valor',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            // disabled: true,
            apiEnv: 'p_ipi_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_ipi_enq: {
            id: 'dem-edi-pro-tab-item-editar--p_ipi_enq',
            status: '',
            nome: 'Enquadramento',
            keyValue: 'ref_ipi_enq',
            keyMostra: [ 'ref_ipi_enq', ' - ', 'ref_ipi_enq_desc' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_ipi_enq',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarEnquadramentoIpi,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_ipi_selo: {
            id: 'dem-edi-pro-tab-item-editar--p_ipi_selo',
            status: '',
            nome: 'Selo',
            keyValue: 'ref_ipi_selo',
            keyMostra: [ 'ref_ipi_selo', ' - ', 'ref_ipi_tipo', ' - ', 'ref_ipi_cor' ],
            options: [],
            optionInicialNome: 'Selecione',
            mostrar: true,
            value: '',
            valueIni: '',
            // disabled: true,
            apiEnv: 'p_ipi_selo',
            onBuscarOptions: this.demEdiProTabItemEditarOnBuscarSeloIpi,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },

          p_fed_bc_v: {
            id: 'dem-edi-pro-doc--p_fed_bc_v',
            status: '',
            value: '0',
            valueIni: '0',
            nome: 'Base de cálculo',
            mask: 'valorMoeda',
            disabled: true,
            apiEnv: 'p_fed_bc_v',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_fed_a: {
            id: 'dem-edi-pro-doc--p_fed_a',
            status: '',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            // disabled: true,
            apiEnv: 'p_fed_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_fed_v: {
            id: 'dem-edi-pro-doc--p_fed_v',
            status: '',
            nome: 'Valor',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            // disabled: true,
            apiEnv: 'p_fed_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_est_bc_v: {
            id: 'dem-edi-pro-doc--p_est_bc_v',
            status: '',
            value: '0',
            valueIni: '0',
            nome: 'Base de cálculo',
            mask: 'valorMoeda',
            disabled: true,
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_est_a: {
            id: 'dem-edi-pro-doc--p_est_a',
            status: '',
            nome: 'Alíquota %',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            // disabled: true,
            apiEnv: 'p_est_a',
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
          p_est_v: {
            id: 'dem-edi-pro-doc--p_est_v',
            status: '',
            nome: 'Valor',
            mask: 'valorMoeda',
            value: '0',
            valueIni: '0',
            // disabled: true,
            apiEnv: 'p_est_v',
            explica: { titulo: '', mensagem: 'Base de cálculo * Alíquota = Valor' },
            onChange: this.demEdiProTabItemEditarOnChangeValue,
            onKeyPressEnter: this.demEdiProTabItemEditarOnKeyPressEnter
          },
        },
        botoes: {
          cancelar: {
            status: '',
            id: 'dem-edi-pro-tab-item-editar-botoes--cancelar',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.demEdiProTabItemEditarFechar(false) }
          },
          salvar: {
            status: '',
            id: 'dem-edi-pro-tab-item-editar-botoes--salvar',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.demEdiProTabItemEditarSalvar() }
          },
        }
      }
    },
    mounted: function () {
      this.demEdiProTabItemEditarIniciar()
    },
    methods: {
      demEdiProTabItemEditarIniciar: function () {
        // SETA O STATUS DA TELA
        this.demEdiProTabItemEditarSetarStatusGeral('carregando')

        // // VERIFICA SE DEVE OU NÃO BUSCAR OS DADOS
        // if ([ '', null, undefined ].indexOf(this.cpntDados) === -1) {
        //   // SETA OS DADOS RECEBIDOS
        //   this.dados = JSON.parse(JSON.stringify(this.cpntDados))

        //   // FINALIZA O CARREGAMENTO DOS DADOS
        //   this.demEdiProTabItemEditarFinalizarCarregamento()
        // } else {
        //   this.demEdiProTabItemEditarBuscarProduto()
        // }

        // FAZ A BUSCA DOS DADOS DO PRODUTO QUE ESTÁ EDITANDO
        this.demEdiProTabItemEditarBuscarProduto()
      },
      demEdiProTabItemEditarFinalizarCarregamento: function () {
        // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
        var chaves = Object.keys(this.campos)

        // REMOVE AS CHAVES QUE NÃO PRECISA CALCULAR
        chaves = chaves.filter(item => [ 'sub_total' ].indexOf(item) === -1)

        // RODA O VETOR DOS CAMPOS
        for (var indexC in chaves) {
          // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
          var chave = chaves[indexC]

          // SETA OS VALORES DO CAMPO
          this.demEdiProTabItemEditarSetarValorCampo(chave)

          // SETA O VALOR INICIAL DO CAMPO
          this.campos[chave].valueIni = this.campos[chave].value
        }

        // MANDA CALCULAR O SUBTOTAL
        this.demEdiProTabItemEditarCalcularSubTotal(true)

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_VERIFICA_COR_LETRA = require('@/assets/js/Funcoes-Gerais.js').FUN_VERIFICA_COR_LETRA

        // VERIFICA SE DEVE COLOCAR COLUNA DE STATUS DO PROCESSO
        this.dados.status_processo = null
        if ([ '', null, undefined ].indexOf(this.dados.id_pco_item) === -1) {
          this.dados.status_processo = {
            tipo: 'venda',
            id: this.dados.id_pco_item,
            nome: this.dados.id_pco_item_nome,
            cor_letra: FUN_VERIFICA_COR_LETRA(this.dados.id_pco_item_cor_fundo),
            cor_fundo: this.dados.id_pco_item_cor_fundo
          }
        }

        // CHAMA A FUNÇÃO PARA CRIAR AS ABAS
        if ([ '', null, undefined ].indexOf(this.abaVal) !== -1) {
          this.demEdiProTabItemEditarCriarAbas()
        }

        // SETA O STATUS DA TELA
        this.demEdiProTabItemEditarSetarStatusGeral('')
      },
      demEdiProTabItemEditarBuscarProduto: function () {
        // INICIA O QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // SETA OS CAMPOS QUE DEVE BUSCAR
        queryGet.field = {
            id: null,
            data: null,
            cod_venda: null,
            id_pro: { j: { codigo: null, nome: null, id_uni: null, ncm: null, status: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } } } },
            p_id_sf2: { j: { id_pro: null, id_con: { j: { nome: null } }, id_uf: null, id_caso: { j: { nome: null } }, id_cfop: { j: { descricao: null } } } },
            qtde: null,
            valor_uni: null,
            valor_tot: null,
            valor_fre: null,
            valor_seg: null,
            valor_des: null,
            valor_oda: null,
            fabricado: null,

            p_id_cfop: { j: { descricao: null } },
            p_icms_orig: { j: { ref_icms_origem_desc: null } },
            p_icms_cst: { j: { ref_icms_cst_desc: null } },
            p_icms_bc_mod: { j: { ref_icms_mod_bc_desc: null } },
            p_icms_a: null,
            p_icms_bc_p_r: null,
            p_icms_bc_p_r_c: null,
            p_icms_st_bc_mod: { j: { ref_icms_mod_bc_st_desc: null } },
            p_icms_st_a: null,
            p_icms_bc_st_p_r: null,
            p_icms_st_bc_rt: null,
            p_icms_st_rt: null,
            p_icms_mva_p: null,
            p_icms_int_a: null,
            p_icms_int_par_p: null,
            p_icms_fcp_a: null,
            p_icms_fcp_st_a: null,
            p_icms_fcp_st_a_cf: null,
            p_icms_fcp_st_r_a: null,
            p_icms_fcp_st_r_bc: null,
            p_icms_bc_v: null,
            p_icms_v: null,
            p_icms_ope_v: null,
            p_icms_dif_v: null,
            p_icms_st_v: null,
            p_icms_st_bc_v: null,
            p_icms_sn_cre_v: null,
            p_icms_int_uf_des_v: null,
            p_icms_int_uf_rem_v: null,
            p_icms_fcp_bc_v: null,
            p_icms_fcp_v: null,
            p_icms_fcp_st_bc_v: null,
            p_icms_fcp_st_v: null,
            p_icms_fcp_st_r_v: null,

            p_pis_cst: { j: { ref_pc_cst_desc: null } },
            p_pis_a: null,
            p_pis_bc_v: null,
            p_pis_v: null,

            p_cofins_cst: { j: { ref_pc_cst_desc: null } },
            p_cofins_a: null,
            p_cofins_bc_v: null,
            p_cofins_v: null,

            p_ipi_cst: { j: { ref_ipi_cst_desc: null } },
            p_ipi_a: null,
            p_ipi_enq: { j: { ref_ipi_enq_desc: null } },
            p_ipi_selo: { j: { ref_ipi_tipo: null, ref_ipi_cor: null } },
            p_ipi_bc_v: null,
            p_ipi_v: null,

            xPed: null,
            cms_com_id: { j: { nome: null } },
            id_pco_item: { j: { id_pco_status_item: { j: { nome: { a: 'id_pco_item_nome' }, cor: { a: 'id_pco_item_cor_fundo' }, id_pco_status: null } } } },

            cms_fec_id: null,
            cms_bc: null,
            cms_por: null,
            cms_valor: null,

            p_fed_a: null,
            p_fed_v: null,
            p_est_a: null,
            p_est_v: null,

            // cs: null,
            cs: { j: { nome: null } },
            // created_at: null,
            // created_user: null,
            status: null
          }

        // SETA O CAMPOS VIRTUAL QUE DEVE BUSCAR
        queryGet.field_virtual = [ 'p_icms_bc_p_r_c_desc' ]

        // VERIFICA SE DEVE COMPARAR OS DADOS DO CASO
        if ((this.cpntPDocNFEmitida === true && [ 'NFCe', 'NFe' ].indexOf(this.cpntPDocTp) !== -1 && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 13 ], null, false) === true) === false) {
          queryGet.field_virtual = queryGet.field_virtual.concat([ 'p_chk_caso' ])
        }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { aAnd: [
          { f: 'status', o: '=', v: '1' },
          { f: 'id', o: '=', v: this.cpntItemId }
        ] }
        
        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/venda/produto/get', 'POST', queryGet, (retorno) => {
          if ([ '', null, undefined ].indexOf(retorno.data) !== -1 || Object.keys(retorno.data).length === 0) {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.msgWarn('WEB [406]: Item (' + this.cpntItemId + ') não foi localizada.', 'warning')
            
            // MANDA FECHAR A TELA
            this.demEdiProTabItemEditarFechar(false)
          } else {
            // VERIFICA SE TEM DIFERENÇA NOS CASO DOS PRODUTOS
            if ([ '', null, undefined ].indexOf(retorno.data[0].virtual_p_chk_caso) === -1) {
              // INICIA O VALOR DO CAMPO
              retorno.data[0].virtual_check_caso = { qtde: 0, diff: {}, caso_atual: '', explica: null }

              // VERIFICA SE TEM ALGUM ERRO
              if (retorno.data[0].virtual_p_chk_caso.code !== '200') {
                // JUNTA OS VALORES RECEBIDOS COM O VALOR DO VETOR
                retorno.data[0].virtual_check_caso.diff = Object.assign(retorno.data[0].virtual_check_caso.diff, retorno.data[0].virtual_p_chk_caso.data)

                // ATUALIZA A QUANTIDADE DE DIFERENÇAS
                retorno.data[0].virtual_check_caso.qtde = Object.keys(retorno.data[0].virtual_check_caso.diff).length

                // SETA A EXPLICAÇÃO
                retorno.data[0].virtual_check_caso.explica = { mensagem: 'Existe(em) ' + retorno.data[0].virtual_check_caso.qtde + ' diferença(s) entre as informações fiscais neste item em relação ao seu cadastro atual. Clique aqui para visualizar as diferenças.', posicaoMy: 'top right', posicaoAt: 'bottom left' }  
              }

              // SETA OS DADOS DO CASO ATUAL
              if ([ '', null, undefined ].indexOf(retorno.data[0].virtual_p_chk_caso.ref) === -1 && [ '', null, undefined ].indexOf(retorno.data[0].virtual_p_chk_caso.ref.id_caso_atual) === -1) {
                retorno.data[0].virtual_check_caso.caso_atual = retorno.data[0].virtual_p_chk_caso.ref.id_caso_atual
              }
            }

            // SETA OS DADOS RECEBIDOS
            this.dados = JSON.parse(JSON.stringify(retorno.data[0]))

            // FINALIZA O CARREGAMENTO DOS DADOS
            this.demEdiProTabItemEditarFinalizarCarregamento()
          }
        }, this.demEdiProTabItemEditarSetarStatusGeral)
      },
      demEdiProTabItemEditarSetarValorCampo: function (chave) {
        // INICIA A VARIAVEL DE VALOR
        var value = ''
        var valueRef = ''
        var options = []

        // VERIFICA O VALOR QUE DEVE SELECIONAR
        switch (chave) {
          case 'item':
            value = { nome: this.dados.id_pro_nome, id_cat_nome: this.dados.id_pro_id_cat_nome, id_mar_nome: this.dados.id_pro_id_mar_nome, codigo: this.dados.id_pro_codigo }
            break

          case 'qtde':
            value = this.dados[chave].replace('.000', '.00')
            break

          case 'xPed':
            value = this.dados[chave]
            break

          case 'p_id_caso':
            // // INICIA O NOME DO CASO
            // var nome = ''

            // // VERIFICA SE TEM VALOR SELECINADO
            // if ([ '', null, undefined ].indexOf(this.dados.p_id_sf2) === -1) {
            //   // SETA O NOME DO CASO
            //   nome += this.dados.p_id_sf2_id_caso_nome

            //   // SETA O NOME DO CONTATO DO CASO
            //   if ([ '', null, undefined ].indexOf(this.dados.p_id_sf2_id_pro) === -1 && this.dados.p_id_sf2_id_pro === this.dados.id_pro) {
            //     nome += ' ' + this.dados.id_pro_nome
            //   }

            //   // SETA O NOME DO CONTATO DO CASO
            //   if ([ '', null, undefined ].indexOf(this.dados.p_id_sf2_id_con_nome) === -1) {
            //     nome += ' ' + this.dados.p_id_sf2_id_con_nome
            //   }

            //   // SETA A UF DO CASO
            //   if ([ '', null, undefined ].indexOf(this.dados.p_id_sf2_id_uf) === -1) {
            //     nome += ' ' + this.dados.p_id_sf2_id_uf
            //   }
            // }

            // // INICIA O NOME DO CASO
            // var nome = ''

            // // VERIFICA SE TEM CASO SELECIONADO
            // if ([ '', null, undefined ].indexOf(this.dados.p_id_sf2_id_caso) === -1) {
            //   // SETA O NOME DO CASO
            //   nome += this.dados.p_id_sf2_id_caso_nome

            //   // SETA O NOME DO CONTATO DO CASO
            //   if ([ '', null, undefined, '0' ].indexOf(this.dados.p_id_sf2_id_pro) === -1) {
            //     nome += ' | ' + this.dados.id_pro_nome
            //   }

            //   // SETA O NOME DO CONTATO DO CASO
            //   if ([ '', null, undefined, '0' ].indexOf(this.dados.p_id_sf2_id_con_nome) === -1) {
            //     nome += ' | ' + this.dados.p_id_sf2_id_con_nome
            //   }

            //   // SETA A UF DO CASO
            //   if ([ '', null, undefined ].indexOf(this.dados.p_id_sf2_id_uf) === -1) {
            //     nome += ' | ' + this.dados.p_id_sf2_id_uf
            //   }

            //   // SETA O NOME DO CONTATO DO CASO
            //   if ([ '', null, undefined ].indexOf(this.dados.p_id_sf2_ncm) === -1) {
            //     nome += ' | NCM ' + this.dados.p_id_sf2_ncm
            //   }

            //   // SETA O NOME DO CONTATO DO CASO
            //   if ([ '', null, undefined ].indexOf(this.dados.p_id_sf2_id_cfop) === -1) {
            //     nome += ' | CFOP ' + this.dados.p_id_sf2_id_cfop + ' - ' + this.dados.p_id_sf2_id_cfop_descricao
            //   }
            // }
            // INICIA O NOME DO CASO
            var nome = ''

            // VERIFICA SE TEM CASO SELECIONADO
            if ([ '', null, undefined ].indexOf(this.dados.p_id_sf2_id_caso) === -1) {
              // SETA O NOME DO CASO
              nome = this.dados.p_id_sf2_id_caso_nome

              // SETA O ESTADO DO CASO
              if ([ '', null, undefined, '0' ].indexOf(this.dados.p_id_sf2_id_uf) === -1) {
                nome += ' | UF: ' + this.dados.p_id_sf2_id_uf
              }

              // SETA O CONTATO DO CASO
              if ([ '', null, undefined, '0' ].indexOf(this.dados.p_id_sf2_id_con_nome) === -1) {
                nome += ' | Contato: ' + this.dados.p_id_sf2_id_con_nome
              }

              // SETA O NCM DO CASO
              if ([ '', null, undefined ].indexOf(this.dados.p_id_sf2_ncm) === -1) {
                nome += ' | NCM: ' + this.dados.p_id_sf2_ncm
              }

              // SETA O CONTATO DO CASO
              if ([ '', null, undefined, '0' ].indexOf(this.dados.p_id_sf2_id_pro) === -1) {
                nome += ' | Produto: ' + this.dados.id_pro_nome
              }

              // SETA O NCM DO CASO
              if ([ '', null, undefined ].indexOf(this.dados.p_id_sf2_id_cfop) === -1) {
                nome += ' | CFOP ' + this.dados.p_id_sf2_id_cfop
                // + ' - ' + this.dados.p_id_sf2_id_cfop_descricao
              }
            }

            // SETA O VALOR QUE DEVE COLOCAR NO CMAPO
            value = { id: this.dados.p_id_sf2, _id_caso_nome: nome }
            break
            
          case 'p_id_cfop':
            value = { cfop: this.dados.p_id_cfop, descricao: this.dados.p_id_cfop_descricao }
            break
            
          case 'p_icms_origem':
            value = { ref_icms_origem_id: this.dados.p_icms_orig, ref_icms_origem_desc: this.dados.p_icms_orig_ref_icms_origem_desc }
            break
            
          case 'p_icms_cst':
            // SETA O NOME DO CAMPO
            this.campos[chave].nome = (this.$store.state.licenca.rt_id === '3' ? 'CST' : 'CSOSN')

            // SETA O VALOR DO CAMPO
            value = { ref_icms_cst: this.dados.p_icms_cst, ref_icms_cst_desc: this.dados.p_icms_cst_ref_icms_cst_desc }
            break
            
          case 'p_icms_mod_bc':
            value = { ref_icms_mod_bc_id: this.dados.p_icms_bc_mod, ref_icms_mod_bc_desc: this.dados.p_icms_bc_mod_ref_icms_mod_bc_desc }
            break
            
          case 'valor_uni':
          case 'valor_tot':
          case 'valor_fre':
          case 'valor_seg':
          case 'valor_des':
          case 'valor_oda':
          case 'p_icms_bc_v':
          case 'p_icms_v':
          case 'p_icms_st_bc_v':
          case 'p_icms_st_v':
          case 'p_pis_bc_v':
          case 'p_pis_v':
          case 'p_cofins_bc_v':
          case 'p_cofins_v':
          case 'p_ipi_bc_v':
          case 'p_ipi_v':
          case 'p_fed_a':
          case 'p_fed_v':
          case 'p_est_a':
          case 'p_est_v':
            value = this.dados[chave]
            break
            
          case 'p_icms_a':
          case 'p_icms_st_a':
          case 'p_icms_bc_st_p_r':
          case 'p_icms_bc_p_r':
          case 'p_icms_mva_p':
          case 'p_pis_a':
          case 'p_cofins_a':
          case 'p_ipi_a':
            // value = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.dados[chave])
            value = ([ '', null, undefined ].indexOf(this.dados[chave]) !== -1 ? '0' : this.dados[chave])
            break

          case 'p_icms_bc_p_r_c':
            value = { id: this.dados.p_icms_bc_p_r_c, nome: this.dados.virtual_p_icms_bc_p_r_c_desc }
            break
            
          case 'p_icms_st_bc_mod':
            value = { ref_icms_mod_bc_st_id: this.dados.p_icms_st_bc_mod, ref_icms_mod_bc_st_desc: this.dados.p_icms_st_bc_mod_ref_icms_mod_bc_st_desc }
            break
            
          case 'p_pis_cst':
            value = { ref_pc_cst: this.dados.p_pis_cst, ref_pc_cst_desc: this.dados.p_pis_cst_ref_pc_cst_desc }
            break
            
          case 'p_cofins_cst':
            value = { ref_pc_cst: this.dados.p_cofins_cst, ref_pc_cst_desc: this.dados.p_cofins_cst_ref_pc_cst_desc }
            break
            
          case 'p_ipi_cst':
            value = { ref_ipi_cst: this.dados.p_ipi_cst, ref_ipi_cst_desc: this.dados.p_ipi_cst_ref_ipi_cst_desc }
            break
            
          case 'p_ipi_enq':
            value = { ref_ipi_enq: this.dados.p_ipi_enq, ref_ipi_enq_desc: this.dados.p_ipi_enq_ref_ipi_enq_desc }
            break
            
          case 'p_ipi_selo':
            value = { ref_ipi_selo: this.dados.p_ipi_selo, ref_ipi_tipo: this.dados.p_ipi_selo_ref_ipi_tipo, ref_ipi_cor: this.dados.p_ipi_selo_ref_ipi_cor }
            break
        }

        // QUEBRA A LIGAÇÃO DO VUE
        value = JSON.parse(JSON.stringify(value))

        // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
        if (options.length >= 1 && typeof value === 'string') {
          // PEGA O VALOR DO CAMPO
          var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

          // SETA O VALOR ENCONTRADO
          value = valor.length === 1 ? valor[0] : value
        }

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos[chave], 'value', value)
        this.$set(this.campos[chave], 'options', options)
        this.$set(this.campos[chave], 'valueRef', valueRef)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProTabItemEditarFechar: function (atualizar) {
        this.cpntFecharFormulario(atualizar)
      },
      demEdiProTabItemEditarSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProTabItemEditarOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA A FUNÇÃO QUE DEVE EXECUTAR PARA CADA CAMPO ATUALIZADO
        switch (indexF[1]) {
          case 'qtde':
          case 'valor_uni':
            this.demEdiProTabItemEditarCalcularValorTotal()
            break

          case 'valor_tot':
          case 'valor_fre':
          case 'valor_seg':
          case 'valor_des':
          case 'valor_oda':
            this.demEdiProTabItemEditarCalcularSubTotal()
            break

          case 'sub_total':
            // ATUALIZA O VALOR DAS BASE DE CALCULOS
            if (this.campos.p_pis_bc_v.value !== value) {
              this.demEdiProTabItemEditarOnChangeValue(value, this.campos.p_pis_bc_v.id)
            }
            if (this.campos.p_cofins_bc_v.value !== value) {
              this.demEdiProTabItemEditarOnChangeValue(value, this.campos.p_cofins_bc_v.id)
            }
            if (this.campos.p_ipi_bc_v.value !== value) {
              this.demEdiProTabItemEditarOnChangeValue(value, this.campos.p_ipi_bc_v.id)
            }
            if (this.campos.p_fed_bc_v.value !== value) {
              this.demEdiProTabItemEditarOnChangeValue(value, this.campos.p_fed_bc_v.id)
            }
            if (this.campos.p_est_bc_v.value !== value) {
              this.demEdiProTabItemEditarOnChangeValue(value, this.campos.p_est_bc_v.id)
            }
            break

          case 'p_pis_bc_v':
          case 'p_pis_a':
            this.demEdiProTabItemEditarCalcularValorImposto('pis')
            break

          case 'p_cofins_bc_v':
          case 'p_cofins_a':
            this.demEdiProTabItemEditarCalcularValorImposto('cofins')
            break

          case 'p_ipi_bc_v':
          case 'p_ipi_a':
            this.demEdiProTabItemEditarCalcularValorImposto('ipi')
            break

          case 'p_fed_bc_v':
          case 'p_fed_a':
            this.demEdiProTabItemEditarCalcularValorImposto('fed')
            break

          case 'p_est_bc_v':
          case 'p_est_a':
            this.demEdiProTabItemEditarCalcularValorImposto('est')
            break
        }
      },
      demEdiProTabItemEditarOnBuscarCFOP: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { cfop: null, descricao: null } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-cfop/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarCFOP(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_id_cfop.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_id_cfop.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarCasos: function (callback) {
        // MONTA O QUERY GET
        var queryGet = {
          p_doc_tp: this.cpntPDocTp,
          id_pro: this.dados.id_pro,
          ncm: this.dados.id_pro_ncm,
          id_con: this.cpntIdCon,
          id_uf: ([ '', null, undefined ].indexOf(this.cpntIdConUF) === -1 ? this.cpntIdConUF : this.$store.state.licenca.uf)
        }

        // SETA O NOME DA DEMANDA QUE DEVE BUSCAR
        switch (this.cpntDemanda) {
          case 'venda':
            queryGet.demanda = 'dem_venda'
            break
        
          case 'dev_cliente':
            queryGet.demanda = 'dem_dev_cliente'
            break

          case 'dev_fornecedor':
            queryGet.demanda = 'dem_dev_fornecedor'
            break
        }

        // CONVERTE O VALOR EM LOT
        queryGet = { lot: [ queryGet ] }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/produto/sit-fiscal2/simulador/get', 'POST', queryGet, (retorno) => {
          // PEGA OS VALORES RETORNADOS
          retorno = retorno.lot[0]

          // VERIFICA SE RECEBEU O RETORNO
          switch (retorno.code) {
            case '200':
              // VERIFICA SE O VALOR EXISTE, POIS A API NÃO RETORNA A CHAVE DATA QUANDO NÃO TEM REGISTRO
              if ([ '', null, undefined ].indexOf(retorno.data) !== -1) {
                retorno.data = []
              }

              // MONTA O NOME DO CASO QUE SERÁ MOSTRADO NO SELETOR
              for (var indexR in retorno.data) {
                // INICIA O NOME DO CASO
                retorno.data[indexR]._id_caso_nome = ''

                // VERIFICA SE TEM CASO SELECIONADO
                if ([ '', null, undefined ].indexOf(retorno.data[indexR].id_caso) === -1) {
                  // SETA O NOME DO CASO
                  retorno.data[indexR]._id_caso_nome = retorno.data[indexR].id_caso_nome

                  // SETA O ESTADO DO CASO
                  if ([ '', null, undefined, '0' ].indexOf(retorno.data[indexR].id_uf) === -1) {
                    retorno.data[indexR]._id_caso_nome += ' | UF: ' + retorno.data[indexR].id_uf
                  }

                  // SETA O CONTATO DO CASO
                  if ([ '', null, undefined, '0' ].indexOf(retorno.data[indexR].id_con_nome) === -1) {
                    retorno.data[indexR]._id_caso_nome += ' | Contato: ' + retorno.data[indexR].id_con_nome
                  }

                  // SETA O NCM DO CASO
                  if ([ '', null, undefined ].indexOf(retorno.data[indexR].ncm) === -1) {
                    retorno.data[indexR]._id_caso_nome += ' | NCM: ' + retorno.data[indexR].ncm
                  }

                  // SETA O CONTATO DO CASO
                  if ([ '', null, undefined, '0' ].indexOf(retorno.data[indexR].id_pro) === -1) {
                    retorno.data[indexR]._id_caso_nome += ' | Produto: ' + retorno.data[indexR].id_pro_nome
                  }

                  // SETA O NCM DO CASO
                  if ([ '', null, undefined ].indexOf(retorno.data[indexR].id_cfop) === -1) {
                    retorno.data[indexR]._id_caso_nome += ' | CFOP ' + retorno.data[indexR].id_cfop
                    // + retorno.data[indexR].id_cfop + ' - ' + retorno.data[indexR].id_cfop_descricao
                  }
                }
              }
    
              // SETA OS VALORES RECEBIDOS
              this.campos.p_id_caso.options = retorno.data

              // VERIFICA SE TEM ALGUM VALOR NO VETOR
              if (retorno.data.length === 0) {
                // REMOVE A FUNÇÃO PARA NÃO ENTRAR EM LOOP INFINITO
                this.campos.p_id_caso.onBuscarOptions = null

                // LIMPA O VALOR SELECIONADO POIS NÃO EXISTE MAIS
                this.campos.p_id_caso.value = ''
              }
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
    
              // EXECUTA A FUNÇÃO CALLBACK
              callback()
              break
          
            default:
              this.$store.state.TRATAR_RET_LOT_API(retorno)
              break
          }

        }, (apiError) => {
          // SETA OS VALORES RECEBIDOS
            this.campos.p_id_caso.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
        })
      },
      // demEdiProTabItemEditarOnBuscarCasos: function (callback, id, total = null, registros = []) {
      //   if (total === null || total < registros.length) {
      //     // PEGA O ESTADO QUE DEVE BUSCAR
      //     var uf = [ '', null, undefined ].indexOf(this.cpntIdConUF) === -1 ? this.cpntIdConUF : this.$store.state.licenca.uf

      //     // MONTA O QUERY GET
      //     var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { id: null, id_pro: { j: { nome: null  } }, id_caso: { j: { nome: null  } }, id_con: { j: { nome: null } }, ncm: null, id_uf: null } }

      //     // SETA O WHERE QUE DEVE REALIZAR
      //     queryGet.where = { aAnd: [
      //       { f: 'status', o: '=', v: '1' },
      //       { f: 'demanda', o: '=', v: 'dem_venda' },
      //       { aOr: [
      //         { f: 'id_pro', o: '=', v: this.dados.id_pro },
      //         { f: 'id_pro', o: '=', v: '' }
      //       ] },
      //       { aOr: [
      //         { f: 'ncm', o: '=', v: this.dados.id_pro_ncm },
      //         { f: 'ncm', o: '=', v: '' }
      //       ] },
      //       { aOr: [
      //         { f: 'id_con', o: '=', v: this.cpntIdCon },
      //         { f: 'id_con', o: '=', v: '0' }
      //       ] },
      //       { aOr: [
      //         { f: 'id_uf', o: '=', v: uf },
      //         { f: 'id_uf', o: '=', v: '' }
      //       ] }
      //     ] }

      //     // SETA A ORDENAÇÃO QUE DEVE APLICAR NOS CAMPOS
      //     queryGet.order = { id_pro: 'desc', ncm: 'desc', id_con: 'desc', id_uf: 'desc' }
  
      //     // FAZ A BUSCA DOS DADOS
      //     this.$store.state.comunicaAPI('/produto/sit-fiscal2/get', 'POST', queryGet, (apiSuccess) => {
      //       // JUNTA OS VALORES RECEBIDOS
      //       registros = registros.concat(apiSuccess.data)

      //       // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
      //       this.demEdiProTabItemEditarOnBuscarCasos(callback, id, Number(apiSuccess.countAll), registros)
      //     }, (apiError) => {
      //       // SETA OS VALORES RECEBIDOS
      //       this.campos.p_id_caso.status = apiError

      //       // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      //       this.time = new Date().getTime()
      //     })
      //   } else if (total === 0) {
      //     // SETA OS VALORES RECEBIDOS
      //     this.campos.p_id_caso.onBuscarOptions = null

      //     // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      //     this.time = new Date().getTime()

      //     // EXECUTA A FUNÇÃO CALLBACK
      //     callback()
      //   } else {
      //     // MONTA O NOME DO CASO QUE SERÁ MOSTRADO NO SELETOR
      //     for (var indexR in registros) {
      //       // INICIA O NOME DO CASO
      //       registros[indexR]._id_caso_nome = ''

      //       // VERIFICA SE TEM CASO SELECIONADO
      //       if ([ '', null, undefined ].indexOf(registros[indexR].id_caso) === -1) {
      //         // SETA O NOME DO CASO
      //         registros[indexR]._id_caso_nome += registros[indexR].id_caso_nome

      //         // SETA O NOME DO CONTATO DO CASO
      //         if ([ '', null, undefined, '0' ].indexOf(registros[indexR].id_pro_nome) === -1) {
      //           registros[indexR]._id_caso_nome += ' | ' + registros[indexR].id_pro_nome
      //         }

      //         // SETA O NOME DO CONTATO DO CASO
      //         if ([ '', null, undefined, '0' ].indexOf(registros[indexR].id_con_nome) === -1) {
      //           registros[indexR]._id_caso_nome += ' | ' + registros[indexR].id_con_nome
      //         }

      //         // SETA A UF DO CASO
      //         if ([ '', null, undefined ].indexOf(registros[indexR].id_uf) === -1) {
      //           registros[indexR]._id_caso_nome += ' | ' + registros[indexR].id_uf
      //         }

      //         // SETA O NOME DO CONTATO DO CASO
      //         if ([ '', null, undefined ].indexOf(registros[indexR].ncm) === -1) {
      //           registros[indexR]._id_caso_nome += ' | NCM ' + registros[indexR].ncm
      //         }

      //         // SETA O NOME DO CONTATO DO CASO
      //         if ([ '', null, undefined ].indexOf(registros[indexR].id_cfop) === -1) {
      //           registros[indexR]._id_caso_nome += ' | CFOP ' + registros[indexR].id_cfop + ' - ' + registros[indexR].id_cfop_descricao
      //         }
      //       }
      //     }

      //     // SETA OS VALORES RECEBIDOS
      //     this.campos.p_id_caso.options = registros

      //     // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      //     this.time = new Date().getTime()

      //     // EXECUTA A FUNÇÃO CALLBACK
      //     callback()
      //   }
      // },
      demEdiProTabItemEditarOnBuscarIcmsModBc: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-mod-bc/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarIcmsModBc(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_icms_mod_bc.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_mod_bc.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarIcmsRedSobre: function (callback) {
        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/referencia/pro-icms-ret-sobre/get', 'GET', null, (apiSuccess) => {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_bc_p_r_c.options = apiSuccess.data

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }, (apiError) => {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_bc_p_r_c.status = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      },
      demEdiProTabItemEditarOnBuscarIcmsModBcSt: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-mod-bc-st/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarIcmsModBcSt(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_icms_st_bc_mod.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_st_bc_mod.options = registros.filter(item => item.ref_icms_mod_bc_st_id !== '-1')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarIcmsOrigem: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-origem/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarIcmsOrigem(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_icms_origem.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_origem.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarCstIcms: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'ref_icms_rt_id', o: '=', v: (this.$store.state.licenca.rt_id === '3' ? '3' : '1,2') }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-cst/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarCstIcms(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_icms_cst.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_icms_cst.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarCstIpi: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-ipi-cst/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabItemEditarOnBuscarCstIpi(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_ipi_cst.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_ipi_cst.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabItemEditarOnBuscarCstPisCofins: function (callback, id, total = null, registros = []) {
        // SETA O NOME DO CAMPOS QUE DEVE ATUALIZAR
        var indexF = id.split('--')[1]

        // VERIFICA SE O CAMPO EXISTE
        if ([ '', null, undefined ].indexOf(this.campos[indexF]) === -1) {
          if (total === null || total < registros.length) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
    
            // FAZ A BUSCA DOS DADOS
            this.$store.state.comunicaAPI('/referencia/pro-pis-cof-cst/get/', 'GET', queryGet, (apiSuccess) => {
              // JUNTA OS VALORES RECEBIDOS
              registros = registros.concat(apiSuccess.data)
  
              // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
              this.demEdiProTabItemEditarOnBuscarCstPisCofins(callback, id, Number(apiSuccess.countAll), registros)
            }, (apiError) => {
              // SETA OS VALORES RECEBIDOS
              this.campos[indexF].status = apiError
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          } else {
            // SETA OS VALORES RECEBIDOS
            this.campos[indexF].options = registros
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
  
            // EXECUTA A FUNÇÃO CALLBACK
            callback()
          }
        }
      },
      demEdiProTabItemEditarOnBuscarSeloIpi: function (callback, id, total = null, registros = []) {
        // SETA O NOME DO CAMPOS QUE DEVE ATUALIZAR
        var indexF = id.split('--')[1]

        // VERIFICA SE O CAMPO EXISTE
        if ([ '', null, undefined ].indexOf(this.campos[indexF]) === -1) {
          if (total === null || total < registros.length) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
    
            // FAZ A BUSCA DOS DADOS
            this.$store.state.comunicaAPI('/referencia/pro-ipi-selo/get/', 'GET', queryGet, (apiSuccess) => {
              // JUNTA OS VALORES RECEBIDOS
              registros = registros.concat(apiSuccess.data)
  
              // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
              this.demEdiProTabItemEditarOnBuscarSeloIpi(callback, id, Number(apiSuccess.countAll), registros)
            }, (apiError) => {
              // SETA OS VALORES RECEBIDOS
              this.campos[indexF].status = apiError
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          } else {
            // SETA OS VALORES RECEBIDOS
            this.campos[indexF].options = registros
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
  
            // EXECUTA A FUNÇÃO CALLBACK
            callback()
          }
        }
      },
      demEdiProTabItemEditarOnBuscarEnquadramentoIpi: function (callback, id, total = null, registros = []) {
        // SETA O NOME DO CAMPOS QUE DEVE ATUALIZAR
        var indexF = id.split('--')[1]

        // VERIFICA SE O CAMPO EXISTE
        if ([ '', null, undefined ].indexOf(this.campos[indexF]) === -1) {
          if (total === null || total < registros.length) {
            // MONTA O QUERY GET
            var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
    
            // FAZ A BUSCA DOS DADOS
            this.$store.state.comunicaAPI('/referencia/pro-ipi-enquadramento/get/', 'GET', queryGet, (apiSuccess) => {
              // JUNTA OS VALORES RECEBIDOS
              registros = registros.concat(apiSuccess.data)
  
              // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
              this.demEdiProTabItemEditarOnBuscarEnquadramentoIpi(callback, id, Number(apiSuccess.countAll), registros)
            }, (apiError) => {
              // SETA OS VALORES RECEBIDOS
              this.campos[indexF].status = apiError
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          } else {
            // SETA OS VALORES RECEBIDOS
            this.campos[indexF].options = registros
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
  
            // EXECUTA A FUNÇÃO CALLBACK
            callback()
          }
        }
      },
      demEdiProTabItemEditarSalvar: function (reinicializar = false) {
        // SETA OS VALORES RECEBIDOS
        this.$set(this.botoes.salvar, 'status', 'carregando')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
        const finalizacao = () => {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.botoes.salvar, 'status', '')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_MONTAR_FORMDATA_API(this.campos, { check_ini: true, disabled: false }).then((formData) => {          
          // VERIFICA SE DEVE REINICIALIZAR OS CAMPOS
          if (reinicializar === true) {
            formData.id_pro_sf = this.dados.p_id_sf2
          }

          // SETA O CODIGO DA VENDA
          formData.cod_venda = this.dados.cod_venda

          // SETA O ID DO ITEM QUE ESTÁ SENDO EDITADO
          formData.id = this.dados.id

          // VERIFICA SE DEVE FORMATAR O CAMPO
          if ([ '', null, undefined ].indexOf(formData.p_fed_v) === -1) {
            formData.p_fed_v = (formData.p_fed_v * 100).toFixed(0).toString()
          }
          if ([ '', null, undefined ].indexOf(formData.p_est_v) === -1) {
            formData.p_est_v = (formData.p_est_v * 100).toFixed(0).toString()
          }
          if ([ '', null, undefined ].indexOf(formData.p_pis_v) === -1) {
            formData.p_pis_v = (formData.p_pis_v * 100).toFixed(0).toString()
          }
          if ([ '', null, undefined ].indexOf(formData.p_cofins_v) === -1) {
            formData.p_cofins_v = (formData.p_cofins_v * 100).toFixed(0).toString()
          }
          if ([ '', null, undefined ].indexOf(formData.p_ipi_v) === -1) {
            formData.p_ipi_v = (formData.p_ipi_v * 100).toFixed(0).toString()
          }

          // CONVERTE O VALOR PARA LOTE
          formData = { lot: [ formData ] }

          // COMUNICA COM A API
          this.$store.state.comunicaAPI('/venda/produto', 'PUT', formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = retorno.lot[0]

            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200' && [ '', null, undefined ].indexOf(formData.lot[0].id_pro_sf) !== -1) {
              this.demEdiProTabItemEditarTratarValidacao(retorno.message, retorno.code, finalizacao)
            } else {
              // MANDA ATUALIZAR A TABELA DO PRODUTO
              this.$emit('DEMANDA_PRODUTO_TABELA_UPDATE')

              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
              
              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              if (reinicializar !== true) {
                this.demEdiProTabItemEditarFechar(true, [ '', null, undefined ].indexOf(retorno.ref) === -1 && [ '', null, undefined ].indexOf(retorno.ref.id) === -1 ? retorno.ref.id : this.cpntId)
              } else {
                // FAZ O PROCESSO DE FINALIZAÇÃO DESTA FUNÇÃO
                finalizacao()

                // MANDA BUSCAR OS DADOS ATUALIZADOS
                this.demEdiProTabItemEditarBuscarProduto()
              }
            }
          }, this.demEdiProTabItemEditarSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiProTabItemEditarTratarValidacao(apiValid, apiStatus, finalizacao) })
        })
      },
      demEdiProTabItemEditarTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.salvar.status = ''

          // DESTRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // MANDA FECHAR A TELA E ATUALIZAR OS DADOS
          this.demEdiProTabItemEditarFechar(true, this.cpntId)
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      demEdiProTabItemEditarCriarAbas: function (callback = null) {
        // LIMPA AS ABAS ENCONTRADAS
        var abaVet = {
          principal: { chave: 'principal', nome: 'Principal', alertas: { qtde: 0, mensagem: '' }, erros: { qtde: 0, mensagem: '' } }
        }

        // VERIFICA SE TEM PACOTE DE NOTA FISCAL
        if ([ 'NFCe', 'NFe' ].indexOf(this.cpntPDocTp) !== -1 && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 23, 20 ], 'or', null, null, null, null, false) === true) {
          // SETA AS ABAS ADICIONAIS
          abaVet.icms =     { chave: 'icms', nome: 'ICMS', alertas: { qtde: 0, mensagem: '' }, erros: { qtde: 0, mensagem: '' } }
          abaVet.pis =      { chave: 'pis', nome: 'PIS', alertas: { qtde: 0, mensagem: '' }, erros: { qtde: 0, mensagem: '' } }
          abaVet.cofins =   { chave: 'cofins', nome: 'COFINS', alertas: { qtde: 0, mensagem: '' }, erros: { qtde: 0, mensagem: '' } }
          abaVet.ipi =      { chave: 'ipi', nome: 'IPI', alertas: { qtde: 0, mensagem: '' }, erros: { qtde: 0, mensagem: '' } }
          abaVet.tributos = { chave: 'tributos', nome: 'Tributos Aproximados', alertas: { qtde: 0, mensagem: '' }, erros: { qtde: 0, mensagem: '' } }

          // VERIFICA SE TEM DIFERENÇAS A SEREM MOSTRADAS
          if ([ '', null, undefined ].indexOf(this.dados.virtual_check_caso) === -1) {
            // INICIA A CHAVE DO VETOR
            var chave = ''

            // VERIFICA AONDE DEVE ADICIONAR AS DIFERENÇAS DOS CASOS
            for (var indexD in this.dados.virtual_check_caso.diff) {
              // LIMPA A CHAVE
              chave = ''

              // VERIFICA O GRUPO QUE DEVE COLOCAR O ALERTA
              switch (indexD) {
                case 'id_cfop':
                case 'icms_cst':
                case 'icms_a':
                case 'icms_st_bc_mod':
                case 'icms_st_a':
                case 'icms_bc_st_p_r':
                case 'icms_mva_p':
                // case 'icms_fcp_st_a':
                  chave = 'icms'
                  break

                case 'pis_cst':
                case 'pis_a':
                  chave = 'pis'
                  break

                case 'cofins_cst':
                case 'cofins_a':
                  chave = 'cofins'
                  break

                case 'ipi_cst':
                case 'ipi_a':
                case 'ipi_enq':
                case 'ipi_selo':
                  chave = 'ipi'
                  break

                case 'fed_bc_v':
                case 'fed_a':
                case 'fed_v':
                case 'est_bc_v':
                case 'est_a':
                case 'est_v':
                  chave = 'tributos'
                  break
              }

              // VERIFICA SE TEM CHAVE A SER ATUALIZADA
              if ([ '', null, undefined ].indexOf(chave) === -1) {
                // SOMA A QUANTIDADE DE ALERTAS
                abaVet[chave].alertas.qtde += 1
  
                // MONTA A MENSAGEM DE ERRO
                abaVet[chave].alertas.mensagem = 'Existe(em) ' + abaVet[chave].alertas.qtde + ' diferença(s) entre as informações fiscais neste item em relação ao seu cadastro atual.'
              }
            }
          }
        }

        // SETA AS ABAS GERADAS
        this.abaVet = abaVet

        // SETA A ABA INICAL
        this.demEdiProTabItemEditarOnChangeAba(Object.keys(abaVet)[0])

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      demEdiProTabItemEditarOnChangeAba: function (aba) {
        // SETA A ABA SELECIONADA
        this.abaVal = aba

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProTabItemEditarVendedorOnClick: function (id) {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', demanda: this.cpntDemanda, id: id, tipo: 'comissao', modelo: 'produto' }
        
        // SETA A FUNÇÃO CALLBACK
        params.callback = (atualizar) => {
          // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
          if (atualizar === true) {
            this.demEdiProTabItemEditarBuscarProduto() 
          }
        }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO', params)
      },
      demEdiProTabItemEditarMontarNomeVendedor: function (linha) {
        // PEGA O NOME DO CONTATO
        var nome = linha.cms_com_id_nome.split(' ')

        // REMOVE TODOS OS VALORES EMBRANCO
        nome = nome.filter(item => item !== '')

        // PEGA A PRIMEIRA LETRA DE CADA PALAVRA
        for (var key in nome) {
          nome[key] = nome[key].substring(0, 1)
        }

        return (linha.cms_com_id + ' - ' + nome.join('')).toUpperCase()
      },
      demEdiProTabItemEditarMontarExplicaVendedor: function (linha) {
        // INICIA A MENSAGEM QUE SERÁ APRESENTADA NA EXPLICAÇÃO
        var mensagem = '<table class="tab-cms-item"><tr><td colspan="2" style="border-right: none"><div>Comissionado:</div>'
        mensagem += linha.cms_com_id + ' - ' + linha.cms_com_id_nome
        mensagem += '</td><td colspan="2" style="border-left: none"><div>Fechamento:</div>'
        mensagem += (linha.cms_fec_id === '' ? '-' : linha.cms_fec_id)
        mensagem += '</td></tr><tr><td><div>Base de Cálculo:</div> R$ '
        mensagem += this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.cms_bc)
        mensagem += '</td><td><div>Porcentagem:</div>'
        mensagem += linha.cms_por + '%'
        mensagem += '</td><td><div>Valor:</div> '
        mensagem += 'R$ ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.cms_valor)
        mensagem += '</td></tr></table>'

        // RETORNA O VALOR MONTADO
        return mensagem
      },
      demEdiProTabItemEditarAbrirControleProcesso: function (linha) {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', id: linha.id, tipo: 'processo', modelo: 'produto' }
        
        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.demEdiProTabItemEditarBuscarProduto()
          }
        }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO', params)
      },
      demEdiProTabItemEditarCalcularValorTotal: function () {
        setTimeout(() => {
          // INICIA O VALOR DO CAMPO
          var valor = 0

          // MULTIPLICA A QUANTIDADE X VALOR UNI
          valor = (Number(this.campos.qtde.value) * Number(this.campos.valor_uni.value)).toFixed(0)

          // FAZ A ATUALIZAÇÃO DO VALOR NO CAMPO
          this.demEdiProTabItemEditarOnChangeValue(valor.toString(), this.campos.valor_tot.id)
        }, 0)
      },
      demEdiProTabItemEditarCalcularSubTotal: function (valorIni = false) {
        setTimeout(() => {
          // INICIA O VALOR DO CAMPO
          var valor = Number(this.campos.valor_tot.value)

          // SOMA O FRETE
          valor += Number(this.campos.valor_fre.value)

          // SOMA O SEGURO
          valor += Number(this.campos.valor_fre.value)

          // RETIRA O DESCONTO
          valor -= Number(this.campos.valor_des.value)

          // SOMA OUTRAS DESPESAS
          valor += Number(this.campos.valor_oda.value)

          // CONVERTE O VALOR EM STRING
          valor = valor.toString()

          // SETA O VALOR INICIAL DO CAMPO
          if (valorIni === true) {
            // SETA OS NOVOS VALORES DOS CAMPOS
            this.campos.sub_total.value = valor
            this.campos.sub_total.valueIni = valor

            // ATUALIZA OS VALORES NOS CAMPOS DEPENDENTES
            this.demEdiProTabItemEditarOnChangeValue(valor, this.campos.p_fed_bc_v.id)
            this.demEdiProTabItemEditarOnChangeValue(valor, this.campos.p_est_bc_v.id)
          } else {
            this.demEdiProTabItemEditarOnChangeValue(valor.toString(), this.campos.sub_total.id)
          }
        }, 0)
      },
      demEdiProTabItemEditarCalcularValorImposto: function (tp) {
        setTimeout(() => {
          // PEGA O VALOR DA BASE DE CALCULO
          var bc = Number(this.campos['p_' + tp + '_bc_v'].value)

          // PEGA O VALOR DA ALIQUOTA
          var procentagem = (Number(this.campos['p_' + tp + '_a'].value) / 100) / 100          

          // CALCULA O VALOR DO CAMPO
          var valor = ((bc * procentagem) / 100).toFixed(2)

          // FORMATA O NUMERO RECEBIDO
          valor = valor.toString()

          // SETA SETA O VALOR DO CAMPO
          if (valor !== this.campos['p_' + tp + '_v'].valueIni) {
            this.demEdiProTabItemEditarOnChangeValue(valor, this.campos['p_' + tp + '_v'].id)
          }
        }, 0)
      }
    },
    computed: {
      demEdiProTabItemEditarGerarNomeCstIcms: function () {
        return this.$store.state.licenca.rt_id === '3' ? 'CST' : 'CSOSN'
      }
    }
  }
</script>
